<template>
    <div class="open-hall">
        <!-- 弹幕层 -->
        <div class="barrage-wrapper">
            <div v-for="item in barrageList" :key="item.id" class="barrage-item" :class="'barrage-track-' + item.track"
                :style="{ opacity: item.visible ? 1 : 0 }">
                {{ item.text }}
            </div>
        </div>
        <div class="open-hall-content">
            <!-- 顶部导航栏 -->
            <div class="top-navbar">
                <div class="navbar-left">
                    <el-button class="back-btn" size="small" icon="el-icon-arrow-left" @click="handleExitHall">
                        返回
                    </el-button>
                    <div class="logo">
                        <span class="logo-text">开标大厅</span>
                        <div class="tts-controls" v-if="roleId != 1">
                            <el-button v-if="!ttsPlaying" type="primary" size="mini" icon="el-icon-microphone"
                                class="tts-btn" @click="startTts">电子唱标</el-button>
                            <template v-else>
                                <el-button size="mini" :icon="ttsPaused ? 'el-icon-video-play' : 'el-icon-video-pause'"
                                    class="tts-btn tts-btn--pause" @click="toggleTtsPause">{{ ttsPaused ? '继续' : '暂停'
                                    }}</el-button>
                                <el-button size="mini" type="danger" icon="el-icon-circle-close" class="tts-btn"
                                    @click="stopTts">停止</el-button>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="navbar-center">
                    <div class="bid-status" :class="{ 'active': isDropdownOpen }" @click="toggleDropdown">
                        <div class="status-label">正在开标:</div>
                        <div class="project-name">{{ projectName }}</div>
                        <i class="el-icon-arrow-down" :class="{ 'rotate': isDropdownOpen }"></i>
                    </div>
                    <!-- 下拉框 -->
                    <div class="project-dropdown" v-show="isDropdownOpen">
                        <div class="dropdown-list">
                            <div v-for="(project, index) in projectList" :key="index" class="dropdown-item"
                                :class="{ 'active': project.id === currentProjectId }" @click="selectProject(project)">
                                <span class="project-title">{{ project.name }}</span>
                                <span class="project-status" :class="project.status">{{ project.statusText }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="navbar-right">
                    <div class="search-box" v-if="roleId != 1">
                        <el-input v-model="searchKeyword" placeholder="输入投标人名称" size="small" style="width: 200px;" />
                        <el-button type="primary" size="small" @click="search">搜索</el-button>
                    </div>
                </div>
            </div>
            <!-- 主要内容区域 -->
            <div class="main-content">
                <!-- 左侧状态面板 -->
                <div class="left-panel">
                    <!-- 当前时间 -->
                    <div class="time-card">
                        <div class="card-header">
                            <span class="card-title">当前时间:</span>
                        </div>
                        <div class="card-content">
                            <div class="time-display">
                                <span class="time">{{ currentTime }}</span>
                                <div class="date">{{ currentDate }}</div>
                            </div>
                        </div>
                    </div>
                    <!-- 开标时间 -->
                    <div class="deadline-card">
                        <div class="card-header">
                            <span class="card-title">开标时间:</span>
                        </div>
                        <div class="card-content">
                            <span class="deadline">{{ openingTime || '--' }}</span>
                        </div>
                    </div>
                    <!-- 解密截止时间 -->
                    <div class="deadline-card">
                        <div class="card-header">
                            <span class="card-title">解密截止时间:</span>
                        </div>
                        <div class="card-content">
                            <span class="deadline">{{ deadLineTime }}</span>
                        </div>
                    </div>
                    <!-- 开标过程 -->
                    <div class="process-card">
                        <div class="card-header">
                            <span class="card-title">开标过程:</span>
                        </div>
                        <div class="card-content">
                            <div class="process-info">
                                <span class="process-text" v-if="roleId != 1">{{ processInfo.info }}</span>
                            </div>
                            <!-- 消息列表 -->
                            <div class="message-list" ref="messageList">
                                <div v-for="(message, index) in filteredMessages" :key="index" class="message-item">
                                    <span class="message-time">{{ formatDateTime(message.createdTime) }}</span>
                                    <span class="message-type">({{ message.senderName }})</span>
                                    <span class="message-content">{{ message.content }}</span>
                                </div>
                            </div>
                            <!-- 消息输入 -->
                            <div class="message-input" v-if="this.roleId == 2">
                                <el-input v-model="newMessage" placeholder="" @keydown.enter="sendMessage"
                                    size="small" />
                                <el-button type="primary" size="small" @click="sendMessage">
                                    发送
                                </el-button>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 右侧表格区域 -->
                <div class="right-panel">
                    <div class="table-container">
                        <!-- 动态表格 -->
                        <el-table :data="dynamicTableData" :key="tableRefreshKey" style="width: 100%" height="100%"
                            border stripe :loading="tableLoading" :row-class-name="getTableRowClassName">
                            <!-- 招标代理专属：解密状态列 -->
                            <el-table-column v-if="isAgent" prop="decryptStatus" label="解密状态" fixed="right" width="120">
                                <template #default="scope">
                                    <span v-if="scope.row.decryptStatus === 2"
                                        class="status-text decrypt-success">解密成功</span>
                                    <span v-else class="status-text decrypt-pending">未解密</span>
                                </template>
                            </el-table-column>
                            <el-table-column v-for="column in dynamicTableColumns" :key="column.prop"
                                :prop="column.prop" :label="column.label" :fixed="column.fixed" :width="column.width">
                                <template v-if="column.prop === 'actions'" #default="scope">
                                    <!-- 投标人操作 -->
                                    <template v-if="isBidder">
                                        <!-- 1: 未解密 (可点击) -->
                                        <span v-if="scope.row.decryptStatus === 1" class="status-text decrypt-pending"
                                            @click="publishBidContent(scope.row)" style="cursor: pointer;">
                                            解密
                                        </span>
                                        <!-- 2: 解密成功 (只展示) -->
                                        <span v-else-if="scope.row.decryptStatus === 2" class="status-text published"
                                            style="cursor: default;">
                                            解密成功
                                        </span>
                                        <!-- 3: 解密失败 (只展示) -->
                                        <span v-else-if="scope.row.decryptStatus === 3"
                                            class="status-text decrypt-failed" style="cursor: default;"
                                            @click="publishBidContent(scope.row)">
                                            解密失败
                                        </span>
                                        <!-- 4: 解密中 (只展示) -->
                                        <span v-else-if="scope.row.decryptStatus === 4" class="status-text decrypting"
                                            style="cursor: default;">
                                            解密中
                                        </span>
                                        <!-- 兜底展示 -->
                                        <span v-else class="status-text decrypt-pending" style="cursor: default;">
                                            未解密
                                        </span>
                                    </template>


                                    <!-- 3 解密失败  4解密中   1:未解密 2:解密成功 -->
                                    <!-- 招标代理操作 -->
                                    <template v-if="isAgent">
                                        <el-button v-if="scope.row.decryptStatus !== 2 && scope.row.guarantee == 0"
                                            type="text" class="action-btn" size="mini"
                                            @click="confirmStartBidGuarantee(scope.row)">
                                            开启开标保障
                                        </el-button>
                                        <el-button type="text" class="action-btn" size="mini"
                                            v-if="scope.row.decryptStatus !== 2 && scope.row.guarantee == 1">
                                            已开启开标保障
                                        </el-button>

                                        <el-button v-if="scope.row.decryptStatus === 2 && scope.row.publishStatus !== 1"
                                            type="text" class="action-btn" size="mini"
                                            @click="publishContent(scope.row)">
                                            公布开标内容
                                        </el-button>
                                        <el-button v-if="scope.row.publishStatus === 1" type="primary" size="mini"
                                            @click="handleViewPublishedContent(scope.row)">
                                            公布开标内容成功
                                        </el-button>
                                    </template>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <!-- 按钮操作区 -->
                    <div class="button-row">
                        <div class="button-group">

                            <el-button type="warning" icon="el-icon-view" @click="handleOpen"
                                v-if="showPublishAllButton">一键公布</el-button>
                            <el-button type="primary" icon="el-icon-document"
                                @click="handleOpenRecordDialog">开标记录</el-button>
                            <el-button type="danger" icon="el-icon-warning" @click="handleQuestion"
                                v-if="roleId == 1">质疑</el-button>
                            <el-button type="success" icon="el-icon-view" @click="handleQuestion" v-else
                                :class="{ 'btn-flash': hasNewQuestion }">查看质疑</el-button>

                            <!-- 抽取按钮（仅代理可见，且 allowSelection === 1 时显示） -->
                            <el-button type="primary" icon="el-icon-magic-stick"
                                v-if="roleId != 1 && allowSelection === 1" :disabled="completed === 1"
                                @click="handleOpenSelectionDialog">
                                {{ completed == 0 ? '抽取' : '系数' + param }}
                            </el-button>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 添加开标记录弹窗 -->
        <el-dialog :title="submitType == 1 ? '查看开标记录' : '添加开标记录'" :visible.sync="addRecordDialogVisible" width="80%"
            :close-on-click-modal="false" :append-to-body="true" class="add-record-dialog">
            <el-form ref="recordFormRef" :model="recordForm" :rules="recordFormRules" label-width="120px"
                class="record-form">
                <!-- 基本信息 -->
                <el-form-item label="开标参与人:" prop="participants" required>
                    <el-input v-model="recordForm.participants" placeholder="请输入开标参与人" style="width: 300px;" disabled>
                    </el-input>
                </el-form-item>

                <el-form-item label="开标时间:" prop="bidOpeningTime" required>
                    <app-date-picker v-model="recordForm.bidOpeningTime" type="datetime" placeholder="请选择开标时间"
                        format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" style="width: 300px;" disabled>
                    </app-date-picker>
                </el-form-item>

                <!-- 富文本编辑器 -->
                <el-form-item label="内容:" prop="content" required>
                    <!-- 只读模式：使用专门的显示区域 -->
                    <div v-if="submitType == 1" class="readonly-rich-content">
                        <div class="content-viewer" v-html="recordForm.content"></div>
                    </div>
                    <!-- 编辑模式：富文本编辑器 -->
                    <RichTextEditor v-else v-model="recordForm.content" ref="recordContentRef" :height="300"
                        placeholder="请输入内容..." toolbar-type="default" />
                </el-form-item>
                <!-- 列表  NO. 投标人编码 投标人名称 签名时间 签名状态 -->
                <el-card shadow="never">
                    <el-table :data="recordForm.list">
                        <el-table-column label="投标人名称" prop="bidderName" />
                        <el-table-column label="签名时间" prop="signTime" />
                        <el-table-column label="签名状态" prop="signStatus">
                            <template slot-scope="scope">
                                <el-button type="success" disabled size="mini">
                                    已签名
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-card>
            </el-form>
            <div slot="footer" class="dialog-footer" style="text-align: center;">
                <!-- 投标人：显示签名按钮 + 关闭 -->
                <template v-if="roleId == 1">
                    <el-button type="primary" @click="handleSign" :disabled="signed" v-if="!signed">
                        {{ signed ? '已签名' : '签名确认' }}
                    </el-button>
                    <el-button @click="addRecordDialogVisible = false" class="action-btn">关闭</el-button>
                </template>
                <!-- 代理：显示暂存和提交按钮 -->
                <template v-else>
                    <template v-if="submitType == 1">
                        <el-button type="primary" icon="el-icon-printer" @click="handlePrintRecord"
                            class="action-btn">打印</el-button>
                        <el-button @click="addRecordDialogVisible = false" class="action-btn">关闭</el-button>
                    </template>
                    <template v-else>
                        <!-- <el-button type="primary" @click="handleSaveDraft(0)" class="action-btn">暂存</el-button> -->
                        <el-button type="primary" @click="handleSaveDraft(1)" class="action-btn">提交</el-button>
                    </template>
                </template>
            </div>
        </el-dialog>
        <!--  投标人 遮挡层 -->
        <div v-if="showBidderMask" class="bidder-mask-overlay">
            <div class="mask-exit-wrapper">
                <el-button class="mask-exit-btn" @click="handleExitHall">退出大厅</el-button>
            </div>
            <div class="content-view">
                <div class="mask-time-card">
                    <div class="mask-time-card__title">{{ sectionName }}</div>
                    <div class="mask-time-grid" style="margin-top: 40px;">
                        <div class="mask-time-item">
                            <div class="mask-time-item__label">开标时间</div>
                            <div class="mask-time-item__value">{{ displayOpeningTime }}</div>
                        </div>
                        <div class="mask-time-item mask-time-item--highlight" style="margin-top: 10px;">
                            <div class="mask-time-item__label">当前时间</div>
                            <div class="mask-time-item__value">{{ displayNowTime }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- CA 登录 / 解密 遮挡层（仅在点击“解密”且未开启开标保障、且 CA 未登录 时显示） -->
        <div v-if="loginDialogVisible" class="oh-unlock-overlay">
            <div class="oh-unlock-overlay-card">
                <div class="oh-unlock-overlay-icon">🔒</div>
                <h2>投标文件解密</h2>
                <p>请选择 CA 用户并完成登录，使用私钥解密后即可公布投标内容。</p>

                <div class="oh-unlock-overlay-info">
                    <div class="oh-unlock-overlay-line">
                        <span>当前标段</span>
                        <strong>{{ sectionName || sectionCode || '-' }}</strong>
                    </div>
                    <div class="oh-unlock-overlay-divider"></div>
                    <div class="oh-unlock-overlay-line">
                        <span>当前选中 CA 名称</span>
                        <strong>{{ currentSelectedCAName || '未选择' }}</strong>
                    </div>
                    <div class="oh-unlock-overlay-line">
                        <span>当前选中 CA ID</span>
                        <strong>{{ loginForm.username || '-' }}</strong>
                    </div>
                    <div class="oh-unlock-overlay-line">
                        <span>CA 登录状态</span>
                        <strong :class="caLoggedIn ? 'is-ok' : 'is-warn'">{{ caLoggedIn ? '已登录' : '未登录' }}</strong>
                    </div>
                </div>

                <div v-if="bidKeyInfo" class="oh-unlock-overlay-info">
                    <div class="oh-unlock-overlay-line">
                        <span>加密时锁证书 ID</span>
                        <strong>{{ bidKeyInfo.caKeyId || bidKeyInfo.cakeyId || '-' }}</strong>
                    </div>
                    <div class="oh-unlock-overlay-line">
                        <span>加密时锁证书名称</span>
                        <strong>{{ bidKeyInfo.caKeyName || '-' }}</strong>
                    </div>
                    <div class="oh-unlock-overlay-line">
                        <span>密文长度</span>
                        <strong>{{ bidKey ? bidKey.length : 0 }}</strong>
                    </div>
                </div>

                <div class="oh-unlock-userlist">
                    <div class="oh-unlock-userlist__head">
                        <span class="oh-unlock-userlist__title">可用 CA 用户</span>
                        <el-button size="mini" type="text" :loading="certRefreshLoading"
                            @click="handleRefreshCertList">刷新</el-button>
                    </div>
                    <el-select v-model="loginForm.username" class="oh-unlock-ca-select" size="small" filterable
                        clearable placeholder="请选择 CA 用户" :loading="certRefreshLoading"
                        :no-data-text="'未检测到证书，请确认 CA 锁已插入并点击刷新'">
                        <el-option v-for="cert in certList" :key="cert.certid" :label="cert.name || cert.certid"
                            :value="cert.certid">
                            <span style="float: left;">{{ cert.name || cert.certid }}</span>
                            <span v-if="caLoggedIn && loginForm.username === cert.certid"
                                style="float: right; color: #16a34a; font-size: 12px;">已登录</span>
                        </el-option>
                    </el-select>
                </div>
                <div v-if="unlockStepText" class="oh-unlock-step-panel" :class="`is-${unlockStepStatus}`">
                    <span class="oh-unlock-step-label">当前操作</span>
                    <strong>{{ unlockStepText }}</strong>
                </div>

                <div class="oh-unlock-overlay-actions">
                    <el-button size="medium" type="primary" :loading="loginLoading" @click="handleLoginSubmit">CA
                        解密</el-button>
                    <el-button size="medium" type="danger" :loading="caLogoutLoading" @click="handleCALogout">CA
                        登出</el-button>
                    <el-button size="medium" @click="handleCloseLoginOverlay">取消</el-button>
                </div>
            </div>
        </div>

        <!-- 河北CA (HBCA) 登录 / 解密 遮挡层 -->
        <div v-if="hbcaDialogVisible" class="oh-unlock-overlay">
            <div class="oh-unlock-overlay-card">
                <div class="oh-unlock-overlay-icon">🔐</div>
                <h2>投标文件解密（河北CA）</h2>
                <p>点击「CA解密」后系统将自动弹出数字证书选择框，请选择用于解密的证书。</p>

                <div class="oh-unlock-overlay-info">
                    <div class="oh-unlock-overlay-line">
                        <span>当前标段</span>
                        <strong>{{ sectionName || sectionCode || '-' }}</strong>
                    </div>
                </div>

                <div v-if="bidKeyInfo" class="oh-unlock-overlay-info">
                    <div class="oh-unlock-overlay-line">
                        <span>加密时锁证书 ID</span>
                        <strong>{{ bidKeyInfo.caKeyId || bidKeyInfo.cakeyId || '-' }}</strong>
                    </div>
                    <div class="oh-unlock-overlay-line">
                        <span>加密时锁证书名称</span>
                        <strong>{{ bidKeyInfo.caKeyName || '-' }}</strong>
                    </div>
                    <div class="oh-unlock-overlay-line">
                        <span>密文长度</span>
                        <strong>{{ bidKey ? bidKey.length : 0 }}</strong>
                    </div>
                </div>

                <div v-if="hbcaError" class="oh-unlock-step-panel is-error">
                    <span class="oh-unlock-step-label">错误</span>
                    <strong>{{ hbcaError }}</strong>
                </div>
                <div v-if="unlockStepText" class="oh-unlock-step-panel" :class="`is-${unlockStepStatus}`">
                    <span class="oh-unlock-step-label">当前操作</span>
                    <strong>{{ unlockStepText }}</strong>
                </div>

                <div class="oh-unlock-overlay-actions">
                    <el-button size="medium" type="primary" :loading="hbcaLoginLoading" @click="handleHbcaDecrypt">CA
                        解密</el-button>
                    <el-button size="medium" @click="handleCloseHbcaOverlay">取消</el-button>
                </div>
            </div>
        </div>

        <!-- 开标保障弹窗 -->
        <el-dialog :visible.sync="guaranteeDialogVisible" title="开标保障" width="420px" :append-to-body="true"
            :close-on-click-modal="!guaranteeSubmitting" :show-close="!guaranteeSubmitting">
            <el-form label-width="80px">
                <el-form-item label="秘钥">
                    <el-input v-model="bidKey" placeholder="请输入秘钥" :disabled="guaranteeSubmitting" />
                </el-form-item>
            </el-form>

            <!-- 解密过程步骤面板 -->
            <div v-if="guaranteeStepText" class="oh-guarantee-step-panel" :class="`is-${guaranteeStepStatus}`">
                <div class="oh-guarantee-step-icon">
                    <span v-if="guaranteeStepStatus === 'loading'" class="oh-guarantee-spinner"></span>
                    <span v-else-if="guaranteeStepStatus === 'success'" class="oh-guarantee-icon-fail-success">✓</span>
                    <span v-else-if="guaranteeStepStatus === 'error'" class="oh-guarantee-icon-fail-error">✕</span>
                </div>
                <div class="oh-guarantee-step-body">
                    <span class="oh-guarantee-step-label">解密进度</span>
                    <strong>{{ guaranteeStepText }}</strong>
                </div>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="handleGuaranteeCancel" :disabled="guaranteeSubmitting">取消</el-button>
                <el-button type="primary" :loading="guaranteeSubmitting" @click="handleGuaranteeSubmit">确定</el-button>
            </span>
        </el-dialog>

        <!-- 质疑列表弹窗（招标代理 + 投标人 共用） -->
        <el-dialog title="质疑信息" :visible.sync="questionDialogVisible" width="65%" :append-to-body="true">
            <!-- 投标人可以新增质疑 -->
            <div style="margin-bottom: 12px;" v-if="roleId == 1">
                <el-button type="primary" size="small" icon="el-icon-plus" @click="showAddComplain">新增质疑</el-button>
            </div>
            <div style="height: 400px;">
                <el-table :data="questionUnitList" style="width: 100%" border height="100%">
                    <el-table-column prop="submitUserName" label="质疑单位" align="center" width="150"></el-table-column>
                    <el-table-column prop="content" label="质疑内容" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column label="操作" width="120" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" size="small"
                                @click="handleViewComplainDetail(scope.row)">详情</el-button>
                            <el-button v-if="roleId == 2 && !scope.row.replyContent" type="text" size="small"
                                @click="handleReply(scope.row)">回复</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="questionDialogVisible = false">关闭</el-button>
            </span>
        </el-dialog>

        <!-- 质疑详情弹窗 -->
        <el-dialog title="质疑详情" :visible.sync="complainDetailVisible" width="50%" :append-to-body="true">
            <div style="padding: 0 20px;">
                <div style="margin-bottom: 16px;">
                    <div style="font-weight: bold; color: #303133; margin-bottom: 6px;">质疑内容</div>
                    <div style="color: #606266; white-space: pre-wrap;">{{ complainDetail.content || '-' }}</div>
                </div>
                <el-divider></el-divider>
                <div v-if="complainDetail.replyContent">
                    <div style="margin-bottom: 16px;">
                        <div style="font-weight: bold; color: #303133; margin-bottom: 6px;">回复内容</div>
                        <div style="color: #67c23a; white-space: pre-wrap;">{{ complainDetail.replyContent }}</div>
                    </div>
                    <div style="margin-bottom: 16px;" v-if="complainDetail.replyContact">
                        <div style="font-weight: bold; color: #303133; margin-bottom: 6px;">回复联系人</div>
                        <div style="color: #606266;">{{ complainDetail.replyContact }} {{ complainDetail.replyPhone ?
                            '(' +
                            complainDetail.replyPhone + ')' : '' }}</div>
                    </div>
                </div>
                <div v-else style="color: #909399; text-align: center; padding: 20px 0;">
                    暂无回复
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="complainDetailVisible = false">关闭</el-button>
                <el-button v-if="roleId == 2 && !complainDetail.replyContent" type="primary"
                    @click="handleReplyFromDetail">回复</el-button>
            </span>
        </el-dialog>

        <!-- 回复质疑弹窗 -->
        <el-dialog title="回复质疑" :visible.sync="replyDialogVisible" width="50%" :append-to-body="true"
            :close-on-click-modal="false">
            <el-form :model="replyForm" ref="replyForm" label-width="120px">
                <el-form-item label="质疑内容:">
                    <div style="color: #606266; white-space: pre-wrap;">{{ replyForm.questionContent }}</div>
                </el-form-item>
                <el-form-item label="回复内容:" prop="replyContent" required>
                    <el-input type="textarea" v-model="replyForm.replyContent" :rows="4"
                        placeholder="请输入回复内容"></el-input>
                </el-form-item>
                <el-form-item label="回复联系人:" prop="replyContact">
                    <el-input v-model="replyForm.replyContact" placeholder="请输入回复联系人"></el-input>
                </el-form-item>
                <el-form-item label="联系电话:" prop="replyPhone">
                    <el-input v-model="replyForm.replyPhone" placeholder="请输入联系电话"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="replyDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitComplainReplyFn" :loading="replySubmitting">提交回复</el-button>
            </span>
        </el-dialog>

        <!-- 投标人新增质疑 -->
        <el-dialog title="新增质疑" :visible.sync="bidderQuestionDialogVisible" width="50%" :append-to-body="true">
            <el-form label-width="100px">
                <el-form-item label="质疑内容:">
                    <el-input type="textarea" v-model="bidderQuestionContent" :rows="5" placeholder="请输入质疑内容" />
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="bidderQuestionDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="handleBidderQuestionSubmit">确定</el-button>
            </span>
        </el-dialog>

        <!-- 抽取系数弹窗 -->
        <el-dialog title="抽取系数" :visible.sync="selectionDialogVisible" width="500px" :close-on-click-modal="false"
            :append-to-body="true" class="selection-dialog" @closed="handleSelectionDialogClosed">
            <div class="selection-dialog-body">
                <!-- 系数范围（始终展示） -->
                <div class="selection-section">
                    <div class="selection-section-title">
                        <i class="el-icon-s-data"></i>
                        系数范围
                    </div>
                    <div class="selection-range-list">
                        <span class="selection-range-item" v-for="(item, idx) in selectionParamList" :key="idx" :class="{
                            'is-filtering': selectionRunning && !selectionResult && getDisplayParam() !== formatSingleParam(item.param),
                            'is-selected': selectionResult && selectionResult.param === item.param
                        }">
                            {{ formatSingleParam(item.param) }}
                        </span>
                    </div>
                </div>

                <!-- 抽取结果区域 -->
                <div class="selection-section selection-result-section">
                    <div class="selection-section-title">
                        <i class="el-icon-magic-stick"></i>
                        抽取结果
                    </div>
                    <!-- 滚动过程中的数字 -->
                    <div class="selection-number-wrap">
                        <div class="selection-result-card" :class="{ 'is-result': !!selectionResult }">
                            <div class="selection-glow" v-if="selectionResult"></div>
                            <div class="selection-number" :class="{
                                'is-running': selectionRunning && !selectionResult,
                                'is-result': !!selectionResult,
                                'is-empty': !selectionRunning && !selectionResult
                            }">
                                {{ getDisplayParam() }}
                            </div>
                            <div class="selection-label">抽取系数</div>
                        </div>
                    </div>

                    <!-- 抽取成功提示 -->
                    <transition name="success-fade">
                        <div class="selection-success" v-if="selectionResult">
                            <div class="success-icon-wrap">
                                <i class="el-icon-circle-check"></i>
                            </div>
                            <span class="success-text">抽取完成：<em>{{ formatSingleParam(selectionResult.param)
                                    }}</em></span>
                        </div>
                    </transition>
                </div>

                <!-- 异常提示 -->
                <transition name="error-fade">
                    <div class="selection-error" v-if="selectionError">
                        <i class="el-icon-warning"></i>
                        <span>{{ selectionError }}</span>
                    </div>
                </transition>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="selectionDialogVisible = false" :disabled="selectionRunning">{{ selectionResult ?
                    '关闭' : '取消'
                    }}</el-button>
                <el-button type="primary" :loading="selectionRunning" :disabled="!!selectionResult"
                    @click="handleConfirmSelection">确定</el-button>
            </span>
        </el-dialog>

    </div>
</template>
<script>
import { useHebcaDecrypt } from '@/api/ca/hbca'
import { getSelectionParamList, randomSelection, getOpeningNow, getOpeningIsMeet, addOpeningRecord, getOpeningListForBidder, publishAll, decryptOpening, startBidGuarantee, getOpeningSwitchList, publish, getOpeningRecordDetail, getOpeningRecord, getBidOpeningInfo, getOpeningDecryptInfo, signNot, getSignNot } from '@/api/modules/agent'
import { sendMessage, getDecryptChatList } from '@/api/modules/chat'
import { getBidKeyInfo, } from '@/api/modules/make'
import RichTextEditor from '@/components/common/RichTextEditor.vue'
import { XTXASynObject } from '@/api/ca/XTXASynObject'
import { useStore } from '@/api/ca/store/index'
import Cookies from 'js-cookie'
import MQTT from '@/utils/network/mqtt'
import { mqttUrl, timeUtils } from '@/utils/base.js'
import EventBus from '@/utils/eventBus'
import { readComplain, createComplain as createComplainApi, getComplainList, getComplainBidderList, submitComplainReply, getComplainDetail } from '@/api/modules/createComplain'
import { subscribeNotice } from '@/utils/network/mqttSubscribe'
export default {
    name: 'OpenHall',
    components: {
        RichTextEditor
    },
    data() {
        return {
            // 信封标识
            envelopeCode: '',
            // ========== 基础配置 ==========
            sectionCode: '',
            projectCode: '',
            sectionName: '',
            roleId: '',
            bidOpeningGuid: '',

            // ========== 项目信息 ==========
            projectName: '',
            currentProjectId: 1,
            projectList: [],
            currentStatus: '评标结束',
            processInfo: {},

            // ========== 时间管理 ==========
            currentTime: '',
            currentDate: '',
            deadLineTime: '',
            openingTime: '',
            nowTime: '',
            timeTimer: null,
            serverNowMs: null,

            // ========== UI 状态 ==========
            isDropdownOpen: false,
            searchKeyword: '',
            tableLoading: false,

            // ========== CA 证书 ==========
            certList: [],
            xtxObject: null,
            store: null,
            bidKey: '',
            bidKeyInfo: null, // getBidKeyInfo 返回的完整加密信息（caKeyId/caKeyName/secretKey 等）
            guarantee: 0,
            caLoggedIn: false,
            defaultCaCertId: 'MSSPDefaultContainer/msspDev000000000000000000',

            // ========== 河北CA (HBCA) ==========
            hbcaLoginLoading: false,
            hbcaDialogVisible: false,
            hbcaError: '',
            _hbcaComposable: null,

            // ========== 登录遮挡层 ==========
            loginDialogVisible: false,
            loginLoading: false,
            caSwitchLoading: false,
            caLogoutLoading: false,
            certRefreshLoading: false,
            unlockStepText: '',
            unlockStepStatus: 'idle', // idle | loading | success | error
            currentDecryptBidderName: '',
            loginForm: {
                username: '',
                password: '111111'
            },

            // ========== 开标保障弹窗 ==========
            guaranteeDialogVisible: false,
            guaranteeSubmitting: false,
            guaranteeStepText: '',
            guaranteeStepStatus: 'idle', // idle | loading | success | error

            mobileCertPreLoginDone: false,

            // ========== 弹幕 ==========
            barrageList: [],
            hasNewQuestion: false,

            // ========== 抽取功能 ==========
            selectionParamList: [],   // 抽取参数列表
            allowSelection: 0,        // 是否允许抽取：1 是，0 否
            completed: 0,             // 是否抽取完成：1 是，0 否
            selectionLoading: false,  // 抽取按钮 loading
            param: 0,

            // ========== 抽取弹窗 ==========
            selectionDialogVisible: false, // 抽取弹窗可见性
            selectionRunning: false,       // 抽取进行中（数字滚动）
            selectionResult: null,         // 抽取结果（最终命中的参数对象）
            displayParam: '',              // 当前展示的数字（滚动中或结果）
            selectionError: '',            // 抽取异常文案
            selectionRollTimer: null,      // 数字滚动定时器
            selectionResultTimer: null,    // 2 秒后揭晓定时器

            // ========== 开标记录弹窗 ==========
            addRecordDialogVisible: false,
            submitType: 0,
            signed: false,
            recordForm: {
                participants: '',
                bidOpeningTime: this.openingTime,
                content: '',
                submitType: 0,
                list: []
            },
            recordFormRules: {
                participants: [{ required: true, message: '请输入开标参与人' }],
                bidOpeningTime: [{ required: true, message: '请选择开标时间' }],
                content: [{ required: true, message: '请输入内容' }]
            },

            // ========== 表格数据 ==========
            dynamicTableData: [],
            originalDynamicTableData: [],
            dynamicTableColumns: [],
            tableRefreshKey: 0, // 表格刷新 key

            // ========== 消息系统 ==========
            newMessage: '',
            messages: [],
            chatTimer: null,
            openingDecryptInfoTimer: null,
            mqttReconnectTimer: null,

            // ========== 质疑功能 ==========
            questionDialogVisible: false,
            questionUnitList: [],
            bidderQuestionDialogVisible: false,
            bidderQuestionContent: '',
            // 质疑详情
            complainDetailVisible: false,
            complainDetail: {},
            // 回复质疑
            replyDialogVisible: false,
            replySubmitting: false,
            replyForm: {
                questionContent: '',
                complaintCode: '',
                replyContent: '',
                replyContact: '',
                replyPhone: ''
            },
            showBidderMask: false,

            // ========== 电子唱标 ==========
            ttsPlaying: false,
            ttsPaused: false,
            ttsCurrentRowIndex: -1,

            // ========== 分页配置 ==========
            pagination: {
                currentPage: 1,
                pageSize: 10,
                total: 1
            }
        }
    },


    computed: {
        channelCode() {
            return this.$channelMaterial.getChannelCode()
        },

        // 当前用户是否为投标人
        isBidder() {
            return this.roleId === '1'
        },
        // 当前用户是否为招标代理
        isAgent() {
            return this.roleId === '2'
        },
        materials() {
            return this.$channelMaterial.getAll()
        },
        maskLogoPath() {
            const logo = this.materials && this.materials.footer ? this.materials.footer.logo : null
            if (!logo || !logo.fileName) {
                return ''
            }
            return this.$channelMaterial.getImagePath(logo.fileName)
        },
        displayOpeningTime() {
            return this.formatMaskDateTime(this.openingTime)
        },
        displayNowTime() {
            if (this.currentDate && this.currentTime) {
                return `${this.currentDate} ${this.currentTime}`
            }
            return this.formatMaskDateTime(this.nowTime)
        },
        displayDeadLineTime() {
            return this.formatMaskDateTime(this.deadLineTime)
        },
        // 电子唱标文本
        ttsText() {
            const columns = (this.dynamicTableColumns || []).filter(c => c.prop && c.prop !== 'actions')
            if (!columns.length || !this.dynamicTableData.length) return '当前暂无开标数据。'
            let text = '开标内容如下。'
            this.dynamicTableData.forEach((row, index) => {
                text += ``
                columns.forEach(col => {
                    const val = row[col.prop]
                    if (val !== undefined && val !== null && val !== '') {
                        text += `${col.label}：${val}，`
                    }
                })
                text += '。'


            })

            return text
        },
        // 是否显示操作列
        shouldShowActions() {
            return this.isBidder || this.isAgent
        },
        currentSelectedCAName() {
            const list = this.certList || []
            const target = list.find(c => c && c.certid === this.loginForm.username)
            return target ? (target.name || '') : ''
        },
        showPublishAllButton() {
            if (!this.isAgent) {
                return false
            }
            const rows = Array.isArray(this.dynamicTableData) ? this.dynamicTableData : []
            // 只要有未公布的就展示
            return rows.some(row => row.publishStatus !== 1)
        },
        // 过滤重复的“进入大厅”消息，确保每个发送人（senderName）只展示一条
        filteredMessages() {
            const seenEnterHall = new Set()
            const list = Array.isArray(this.messages) ? this.messages : []
            return list.filter(msg => {
                if (msg && msg.content === '进入大厅') {
                    const sender = msg.senderName ? String(msg.senderName).trim() : ''
                    if (seenEnterHall.has(sender)) {
                        return false
                    }
                    seenEnterHall.add(sender)
                }
                return true
            })
        }
    },
    created() {
        this.sectionCode = this.$route.query.sectionCode
        this.store = useStore()
        this.xtxObject = new XTXASynObject()
        this._hbcaComposable = useHebcaDecrypt()
    },
    mounted() {
        this.setEnvelopeCode()
        // 初始化消息和质疑数据
        this.initMockData()
        // 添加点击外部关闭下拉框的事件监听
        document.addEventListener('click', this.handleClickOutside)
        // 初始化页面数据
        this.init()
        this.initMqttNotice()
        // 招标代理专属


    },
    methods: {

        // 如果路由里面存在一信封标识或二信封标识，则设置一信封标识或二信封标识
        setEnvelopeCode() {
            if (this.$route.query.envelopeCode) {
                this.envelopeCode = this.$route.query.envelopeCode
            }
        },
        async initMqttNotice() {
            await subscribeNotice(this.$channelMaterial.getChannelCode(), {
                onMessage: (msg) => {
                    if (msg.sectionCode === this.sectionCode) {
                        if (msg.msgType == 13) {
                            this.addBarrage(msg.msg)
                            this.flashQuestionButton()
                        }
                    }
                }
            })
        },
        // ==================== 初始化方法 ====================

        // ==================== 弹幕 ==========
        addBarrage(text) {
            const id = Date.now() + Math.random()
            const track = this.barrageList.length % 4
            this.barrageList.push({ id, text, track, visible: true })
            setTimeout(() => {
                const index = this.barrageList.findIndex(b => b.id === id)
                if (index !== -1) {
                    this.barrageList[index].visible = false
                }
                setTimeout(() => {
                    this.barrageList = this.barrageList.filter(b => b.id !== id)
                }, 200)
            }, 25000)
        },

        // 质疑按钮闪烁 1 秒
        flashQuestionButton() {
            console.log();

            this.hasNewQuestion = true
            setTimeout(() => {
                this.hasNewQuestion = false
            }, 1000)
        },

        // ==================== 电子唱标 ====================
        startTts() {
            if (!window.speechSynthesis) {
                this.$message.error('当前浏览器不支持语音合成')
                return
            }
            window.speechSynthesis.cancel()
            const columns = (this.dynamicTableColumns || []).filter(c => c.prop && c.prop !== 'actions')
            if (!columns.length || !this.dynamicTableData.length) {
                this.$message.warning('当前暂无开标数据')
                return
            }
            const totalRows = this.dynamicTableData.length
            const utterList = []
            this.dynamicTableData.forEach((row, index) => {
                const rowText = columns.map(col => {
                    const val = row[col.prop]
                    return (val !== undefined && val !== null && val !== '') ? `${col.label}：${val}` : null
                }).filter(Boolean).join('，')
                const utter = new SpeechSynthesisUtterance(`${rowText}`)
                utter.lang = 'zh-CN'
                utter.rate = 0.9
                utter.pitch = 1
                utter._rowIndex = index
                utter.onstart = () => {
                    this.ttsPlaying = true
                    this.ttsPaused = false
                    this.ttsCurrentRowIndex = utter._rowIndex
                }
                utter.onend = () => {
                    if (utter._rowIndex === totalRows - 1) {
                        this.ttsPlaying = false
                        this.ttsPaused = false
                        this.ttsCurrentRowIndex = -1
                    }
                }
                utter.onerror = () => {
                    this.ttsPlaying = false
                    this.ttsPaused = false
                    this.ttsCurrentRowIndex = -1
                }
                utterList.push(utter)
            })
            utterList.forEach(u => window.speechSynthesis.speak(u))
        },
        toggleTtsPause() {
            if (!window.speechSynthesis) return
            if (this.ttsPaused) {
                window.speechSynthesis.resume()
                this.ttsPaused = false
            } else {
                window.speechSynthesis.pause()
                this.ttsPaused = true
                this.ttsCurrentRowIndex = -1
            }
        },
        stopTts() {
            if (window.speechSynthesis) window.speechSynthesis.cancel()
            this.ttsPlaying = false
            this.ttsPaused = false
            this.ttsCurrentRowIndex = -1
        },
        getTableRowClassName({ rowIndex }) {
            if (rowIndex === this.ttsCurrentRowIndex) {
                return 'tts-highlight-row'
            }
            return ''
        },

        // 初始化页面
        init() {
            this.sectionCode = this.$route.query.sectionCode
            this.roleId = Cookies.get('roleId')
            this.projectCode = this.$route.query.projectCode
            if (this.roleId === '1') {
                this.getBidKey()
                this.getBidOpeningInfo()
                this.initCertList()

            } else {
                this.getOpeningSwitchList()
                this.GetSelectionParamList()

            }

        },



        //  获取抽取系数和抽泣状态
        async GetSelectionParamList() {
            console.log('获取抽取系数和抽泣状态');

            const res = await getSelectionParamList(this.sectionCode)
            console.log(res);
            if (res.code === 200) {
                const data = res.data || {}
                this.param = res.data.param
                // selectionParamList 中的 param 是系数，rate 是抽中比例
                // rate 为 0 则随机抽取；其中有一个为 1 则必中
                this.selectionParamList = Array.isArray(data.selectionParamList) ? data.selectionParamList : []
                this.allowSelection = typeof data.allowSelection === 'number' ? data.allowSelection : 0
                this.completed = typeof data.completed === 'number' ? data.completed : 0

            } else {
                this.$message.error(res.msg)

            }

        },

        // 点击抽取按钮 —— 打开弹窗
        handleOpenSelectionDialog() {
            if (this.completed === 1) {
                this.$message.warning('已抽取完成，无需再次抽取')
                return
            }
            if (!Array.isArray(this.selectionParamList) || this.selectionParamList.length === 0) {
                this.$message.warning('暂无可抽取的参数')
                return
            }
            // 重置弹窗状态
            this.selectionResult = null
            this.selectionError = ''
            this.selectionRunning = false
            this.displayParam = ''
            this.selectionDialogVisible = true
        },

        // 弹窗关闭清理
        handleSelectionDialogClosed() {
            this.clearSelectionTimers()
            this.selectionResult = null
            this.selectionError = ''
            this.selectionRunning = false
            this.displayParam = ''
        },

        clearSelectionTimers() {
            if (this.selectionRollTimer) {
                clearInterval(this.selectionRollTimer)
                this.selectionRollTimer = null
            }
            if (this.selectionResultTimer) {
                clearTimeout(this.selectionResultTimer)
                this.selectionResultTimer = null
            }
        },

        // 弹窗内“确定”按钮 —— 启动抽取（数字滚动 + 2 秒后揭晓）
        async handleConfirmSelection() {
            if (this.completed === 1) {
                this.$message.warning('已抽取完成，无需再次抽取')
                return
            }
            if (!Array.isArray(this.selectionParamList) || this.selectionParamList.length === 0) {
                this.$message.warning('暂无可抽取的参数')
                return
            }

            // 按规则挑选 paramId：
            // 1) 若所有 rate === 0：随机抽取
            // 2) 若存在 rate === 1：取该条（必中）
            let target = null
            const mustSelected = this.selectionParamList.filter(item => Number(item.rate) === 1)
            if (mustSelected.length > 0) {
                target = mustSelected[0]
            } else {
                const randomIndex = Math.floor(Math.random() * this.selectionParamList.length)
                target = this.selectionParamList[randomIndex]
            }

            if (!target || !target.id) {
                this.selectionError = '抽取参数异常，无法抽取'
                return
            }

            // 启动数字滚动
            this.selectionError = ''
            this.selectionResult = null
            this.selectionRunning = true
            this.displayParam = this.formatParamDisplay(this.selectionParamList)
            this.startParamRoll()

            try {
                const res = await randomSelection(target.id)
                if (res.code === 200) {
                    // 2 秒后揭晓真正的结果
                    this.selectionResultTimer = setTimeout(() => {
                        this.stopParamRoll()
                        this.selectionRunning = false
                        this.selectionResult = target
                        this.displayParam = ''
                        // 同步刷新全局状态（allowSelection / completed）
                        this.GetSelectionParamList()
                    }, 2000)
                } else {
                    this.stopParamRoll()
                    this.selectionRunning = false
                    this.selectionError = res.msg || '抽取失败'
                    this.$message.error(res.msg || '抽取失败')
                }
            } catch (err) {
                this.stopParamRoll()
                this.selectionRunning = false
                this.selectionError = (err && err.message) ? err.message : '抽取失败'
                this.$message.error(this.selectionError)
            }
        },

        // 启动数字滚动（每 60ms 在 selectionParamList 中随机切换）
        startParamRoll() {
            this.clearSelectionTimers()
            this.selectionRollTimer = setInterval(() => {
                if (!Array.isArray(this.selectionParamList) || this.selectionParamList.length === 0) return
                const randomIndex = Math.floor(Math.random() * this.selectionParamList.length)
                const item = this.selectionParamList[randomIndex]
                this.displayParam = this.formatSingleParam(item.param)
            }, 60)
        },

        // 停止滚动
        stopParamRoll() {
            if (this.selectionRollTimer) {
                clearInterval(this.selectionRollTimer)
                this.selectionRollTimer = null
            }
        },

        // 数字滚动展示文本：取首个作为初始值
        formatParamDisplay(list) {
            if (!Array.isArray(list) || list.length === 0) return ''
            return this.formatSingleParam(list[0].param)
        },

        // 当前展示的系数：滚动中显示动态数字，否则为空（结果由下方 success 行展示）
        getDisplayParam() {
            if (this.selectionRunning) return this.displayParam
            if (this.selectionResult) return ''
            return ''
        },

        formatSingleParam(val) {
            if (val === null || val === undefined || val === '') return ''
            const num = Number(val)
            if (isNaN(num)) return String(val)
            // 保留两位小数，与后端系数精度保持一致
            return num.toFixed(2).replace(/\.?0+$/, '')
        },

        //标大厅解密信息
        async getOpeningDecryptInfo() {
            const res = await getOpeningDecryptInfo(this.sectionCode)
            if (res.code === 200) {

                const oldTopic = this.processInfo && this.processInfo.topic
                this.processInfo = res.data;
                this.getDecryptChatList()
                if (this.processInfo.topic && this.processInfo.topic !== oldTopic) {
                    this.initMqtt(this.processInfo.topic)
                }
                this.startOpeningDecryptInfoTimer()
            } else {
                this.handleApiError(res.msg)
            }
        },

        startOpeningDecryptInfoTimer() {
            if (this.openingDecryptInfoTimer) return
            if (MQTT.isConnected()) return
            this.openingDecryptInfoTimer = setInterval(() => {
                if (MQTT.isConnected()) {
                    this.stopOpeningDecryptInfoTimer()
                    return
                }
                this.getOpeningDecryptInfo()
            }, 5000)
        },

        stopOpeningDecryptInfoTimer() {
            if (this.openingDecryptInfoTimer) {
                clearInterval(this.openingDecryptInfoTimer)
                this.openingDecryptInfoTimer = null
            }
        },

        //获取聊天记录接口
        async getDecryptChatList() {
            try {
                const res = await getDecryptChatList(this.processInfo.topic)
                if (res.code === 200) {

                    this.$nextTick(() => {
                        this.scrollToBottom()
                    })
                    this.messages = res.data
                } else {
                    this.handleApiError(res.msg)
                }
            } catch (error) {
                this.handleApiError('获取聊天记录失败+网络异常', error)
            }
            if (!this.chatTimer && !MQTT.isConnected()) {
                this.chatTimer = setInterval(() => {
                    if (MQTT.isConnected()) {
                        this.stopChatTimer()
                        return
                    }
                    this.getDecryptChatList()
                }, 5000)
            }
        },

        stopChatTimer() {
            if (this.chatTimer) {
                clearInterval(this.chatTimer)
                this.chatTimer = null
            }
        },

        // 初始mqtt
        initMqtt(topic) {
            this.startMqttReconnectTimer(topic)
            MQTT.connect(mqttUrl, {
                username: '',
                password: '',
                clientId: Math.floor(Math.random() * 1000000000000000000),
                keepalive: 60,
                clean: true
            })
            MQTT.on('connect', (e) => {
                console.log("监听连接成功");
                this.stopMqttReconnectTimer()
                if (this.isBidder) {
                    // 投标人需先判断是否具备进入开标大厅条件，满足条件（res.code === 200）才发送"进入大厅"消息
                    this.handleBidderEnterHall()
                }
            })
            //  获取到mqtt消息
            MQTT.subscribe(topic, (message) => {
                console.log(message);

                //  如果是投标人的话 只保留对应投标人的信息
                const userName = Cookies.get('userName')
                if (this.isBidder) {
                    if (message.content == '进入大厅' || message.content == '开始解密')
                        if (userName != message.senderName) {
                            return
                        }
                } else {
                    this.getOpeningList()
                }
                const obj = JSON.parse(message);
                this.messages.push(obj)
                this.sectionCode = this.$route.query.sectionCode
                this.roleId = Cookies.get('roleId')
                this.projectCode = this.$route.query.projectCode
                if (obj.sectionCode === this.sectionCode) {
                    this.addBarrage(obj.msg || '您有一条质疑消息')
                    this.flashQuestionButton()
                }
                this.$nextTick(() => {
                    this.scrollToBottom()
                })
            }, { qos: 2 })
            MQTT.on('error', (err) => {
                console.error('链接失败', err)
                this.startMqttReconnectTimer(topic)
            })
        },

        // 启动 MQTT 重连定时器
        startMqttReconnectTimer(topic) {
            if (this.mqttReconnectTimer) return
            this.mqttReconnectTimer = setInterval(() => {
                if (MQTT.isConnected()) {
                    this.stopMqttReconnectTimer()
                    return
                }
                console.log('MQTT 未连接，启动重连...')
                MQTT.connect(mqttUrl, {
                    username: '',
                    password: '',
                    clientId: Math.floor(Math.random() * 1000000000000000000),
                    keepalive: 60,
                    clean: true
                })
            }, 5000)
        },

        // 停止 MQTT 重连定时器
        stopMqttReconnectTimer() {
            if (this.mqttReconnectTimer) {
                clearInterval(this.mqttReconnectTimer)
                this.mqttReconnectTimer = null
            }
        },

        // 初始化模拟数据（后续可替换为接口数据）
        initMockData() {

            this.$nextTick(() => this.scrollToBottom())
        },
        // ==================== 工具方法 ====================

        // 统一错误处理
        handleApiError(message, error = null) {
            this.$message.error(message)
        },

        // 统一成功提示
        handleApiSuccess(message) {
            this.$message.success(message)
        },

        // ==================== 数据获取方法 ====================

        // 投标人-获取开标信息
        async getBidOpeningInfo() {
            try {
                const res = await getBidOpeningInfo(this.sectionCode)
                if (res.code === 200) {
                    this.updateResInfo(res)
                    this.getOpeningDecryptInfo()
                } else {
                    this.handleApiError(res.msg || '获取开标信息失败')
                }
            } catch (error) {
                this.handleApiError('获取开标信息失败', error)
            }
        },
        // 获取开标大厅切换列表
        async getOpeningSwitchList() {
            try {
                const res = await getOpeningSwitchList(this.projectCode)
                if (res.code === 200) {
                    this.updateResInfo(res)
                } else {
                    this.handleApiError(res.msg || '获取开标大厅切换列表失败')
                }
            } catch (error) {
                this.handleApiError('获取开标大厅切换列表失败', error)
            }
        },
        // 统一处理返回结果
        updateResInfo(res) {
            const statusMap = {
                1: { status: 'pending', text: '未开始' },
                2: { status: 'active', text: '进行中' },
                3: { status: 'completed', text: '结束' }
            }
            // 接口数据映射到下拉使用的 projectList
            this.projectList = res.data.map(item => {
                const map = statusMap[item.bidSectionStatus] || statusMap[1]
                return {
                    id: item.bidSectionCode,
                    name: item.bidSectionName,
                    status: map.status,
                    statusText: map.text,
                    bidSectionCode: item.bidSectionCode,
                    bidSectionName: item.bidSectionName,
                    bidSectionStatus: item.bidSectionStatus
                }
            })
            // 依据 sectionCode 或第一条初始化当前选中项目
            if (this.projectList.length > 0) {
                let current = this.projectList[0]
                if (this.sectionCode) {
                    const found = this.projectList.find(p => p.bidSectionCode === this.sectionCode)
                    if (found) {
                        current = found
                    }
                }
                this.sectionCode = current.bidSectionCode
                this.sectionName = current.bidSectionName
                this.currentProjectId = current.id
                this.projectName = current.name
                this.updateProjectInfo(current)
                // 初始化右侧数据
                this.initHttp()
            }

        },
        initHttp() {
            this.getOpeningNow()// 获取当前时间
            this.getOpeningIsMeet()// 判断是否具备进入开标大厅条件
            if (this.roleId != 2) {
                this.addOpeningRecord()
            } else {
                this.getOpeningList()
            }

        },
        // 获取服务器时间并启动定时器
        async getOpeningNow() {
            try {
                const res = await getOpeningNow(this.sectionCode)
                if (res.code === 200) {
                    this.openingTime = res.data.openingTime || ''
                    this.deadLineTime = res.data.deadLineTime
                    this.nowTime = res.data.nowTime || ''
                    this.initServerTime(res.data.nowTime)
                } else {
                    this.handleApiError(res.msg || '获取服务器时间失败')
                }
            } catch (error) {
                this.handleApiError('获取服务器时间失败', error)
            }
        },

        // 初始化服务器时间
        initServerTime(timeStr) {
            try {
                let dateObj = null
                if (typeof timeStr === 'string' && /^\d{14}$/.test(timeStr)) {
                    dateObj = new Date(timeStr.slice(0, 4), timeStr.slice(4, 6) - 1, timeStr.slice(6, 8), timeStr.slice(8, 10), timeStr.slice(10, 12), timeStr.slice(12, 14))
                } else if (typeof timeStr === 'number') {
                    dateObj = new Date(timeStr)
                }
                if (!dateObj) {
                    console.warn('时间格式不正确:', timeStr)
                    return
                }
                this.serverNowMs = dateObj.getTime()
                this.updateTime()
                this.startTimeTimer()
            } catch (error) {
                console.error('更新时间失败:', error)
            }
        },

        // 启动时间定时器
        startTimeTimer() {
            this.clearTimeTimer()
            this.timeTimer = setInterval(() => {
                this.serverNowMs += 1000
                this.updateTime()
            }, 1000)
        },

        // 清理时间定时器
        clearTimeTimer() {
            if (this.timeTimer) {
                clearInterval(this.timeTimer)
                this.timeTimer = null
            }
        },
        formatMaskDateTime(value) {
            if (!value) {
                return '--'
            }
            if (typeof value === 'string' && /^\d{14}$/.test(value)) {
                return `${value.slice(0, 4)}-${value.slice(4, 6)}-${value.slice(6, 8)} ${value.slice(8, 10)}:${value.slice(10, 12)}:${value.slice(12, 14)}`
            }
            return value
        },
        parseMaskDateTime(value) {
            if (!value || typeof value !== 'string') {
                return null
            }
            if (/^\d{14}$/.test(value)) {
                return new Date(value.slice(0, 4), value.slice(4, 6) - 1, value.slice(6, 8), value.slice(8, 10), value.slice(10, 12), value.slice(12, 14))
            }
            if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(value)) {
                const normalized = value.replace(/-/g, '/')
                const date = new Date(normalized)
                return isNaN(date.getTime()) ? null : date
            }
            return null
        },
        //是否具备进入开标大厅条件
        async getOpeningIsMeet() {
            const res = await getOpeningIsMeet(this.sectionCode)
            if (res.code === 200) {
                this.showBidderMask = false
                this.getOpeningDecryptInfo()
            } else if (res.code === 9025) {
                this.$message.error(res.msg)
                setTimeout(() => {
                    this.$router.go(-1)
                }, 1000);
            } else {
                if (this.isBidder) {
                    this.showBidderMask = true
                }
            }
        },
        // ==================== 搜索与筛选 ====================

        // 搜索（本地精确匹配投标人名称）
        search() {
            const keyword = (this.searchKeyword || '').trim()
            if (!keyword) {
                this.dynamicTableData = this.originalDynamicTableData ? [...this.originalDynamicTableData] : []
                return
            }
            const source = this.originalDynamicTableData || []
            this.dynamicTableData = source.filter(row => row.bidderName === keyword)
        },
        // ==================== 质疑功能 ====================

        // 处理质疑按钮点击
        handleQuestion() {
            // 招标代理和投标人都查看质疑列表
            this.fetchComplainList()

        },
        async readComplain() {
            const res = await readComplain('bidOpen', { sectionCode: this.sectionCode })
            if (res.code === 200) {
            } else {
                this.$message.error(res.msg)
            }
        },




        // 投标人点击“新增质疑”按钮
        showAddComplain() {
            this.bidderQuestionContent = ''
            this.bidderQuestionDialogVisible = true
        },
        // 获取质疑列表
        async fetchComplainList() {
            let data = {
                complaintType: 'bidOpen',
                projectCode: this.projectCode,
                bidSectionCode: this.sectionCode,
                pageNum: 1,
                pageSize: 50,
                stage: 0
            }
            const res = this.roleId == 1
                ? await getComplainBidderList('bidOpen', data)
                : await getComplainList('bidOpen', data)
            if (res.code === 200) {
                if (res.data.records.length > 0) {
                    this.questionUnitList = res.data.records
                    this.questionDialogVisible = true
                    this.readComplain()
                } else {
                    if (this.roleId == 1) {
                        // 投标人没有质疑时直接弹出新增
                        this.showAddComplain()
                    } else {
                        this.$message.info('暂无质疑')
                    }
                }
            } else {
                this.$message.error(res.msg)
            }
        },
        // 查看质疑详情
        async handleViewComplainDetail(row) {
            try {
                const res = await getComplainDetail('bidOpen', { complaintCode: row.complaintCode })
                if (res.code === 200) {
                    this.complainDetail = res.data || row
                } else {
                    this.complainDetail = row
                }
            } catch (error) {
                this.complainDetail = row
            }
            this.complainDetailVisible = true
        },
        // 从详情页进入回复
        handleReplyFromDetail() {
            this.complainDetailVisible = false
            this.handleReply(this.complainDetail)
        },
        // 回复质疑
        handleReply(row) {
            this.replyForm = {
                questionContent: row.content,
                complaintCode: row.complaintCode,
                replyContent: '',
                replyContact: '',
                replyPhone: ''
            }
            this.replyDialogVisible = true
        },
        // 提交回复
        async submitComplainReplyFn() {
            if (!this.replyForm.replyContent || !this.replyForm.replyContent.trim()) {
                this.$message.warning('请输入回复内容')
                return
            }
            this.replySubmitting = true
            try {
                const data = {
                    complaintType: 'bidOpen',
                    complaintCode: this.replyForm.complaintCode,
                    replyContent: this.replyForm.replyContent,
                    replyContact: this.replyForm.replyContact,
                    replyPhone: this.replyForm.replyPhone,
                    replyFileGuid: ''
                }
                const res = await submitComplainReply('bidOpen', data)
                if (res.code === 200) {
                    this.$message.success('回复成功')
                    this.replyDialogVisible = false
                    this.fetchComplainList()
                } else {
                    this.$message.error(res.msg || '回复失败')
                }
            } catch (error) {
                console.error('回复失败:', error)
                this.$message.error('回复失败，请重试')
            } finally {
                this.replySubmitting = false
            }
        },
        // 提交质疑
        handleBidderQuestionSubmit() {
            if (!this.bidderQuestionContent || !this.bidderQuestionContent.trim()) {
                this.$message.warning('请输入质疑内容')
                return
            }
            this.createComplain()
        },
        // 保存质疑(投标人)
        createComplain() {
            let data = {
                bidSectionCode: this.sectionCode,
                bidSectionName: this.sectionName,
                complaintType: 'bidOpen',
                content: this.bidderQuestionContent,
                projectCode: this.projectCode,
                status: 1,
                submitContact: this.bidderQuestionContent,
                submitUserName: Cookies.get('userName'),
                title: this.bidderQuestionContent,
                channelCode: this.channelCode
            }
            createComplainApi('bidOpen', data).then(res => {
                if (res.code === 200) {
                    this.bidderQuestionDialogVisible = false
                    this.$message.success('质疑成功')
                    this.fetchComplainList()
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        // ==================== CA证书相关 ====================

        isMobileCert(cert) {
            try {
                const name = (cert && cert.name) ? String(cert.name) : ''
                if (!name) return false
                return /\u79fb\u52a8|\u624b\u673a|mobile/i.test(name)
            } catch (e) {
                return false
            }
        },

        isXtxLoginSuccess(retVal) {
            const v = String(retVal)
            if (!v) return false
            return v !== '0' && v.toLowerCase() !== 'false'
        },

        async refreshCertList({ clearSelection } = {}) {
            await this.xtxObject.SOF_GetUserList()
            await this.$nextTick()
            const certList = this.store.state.XTXModel.ukeyList || []
            this.certList = certList
            if (clearSelection) {
                this.loginForm.username = ''
            } else if (!this.loginForm.username && this.certList.length > 0) {
                const selectedCert = this.certList[0]
                this.loginForm.username = selectedCert.certid
            }
        },

        // 初始化证书列表
        async initCertList() {
            try {
                // 如果使用 HBCA（河北CA），跳过普通 CA 证书助手检测
                const caType = this.$channelMaterial.getCaType()
                if (caType === 'HBCA') {
                    console.log('使用 HBCA，跳过普通 CA 证书助手检测')
                    // HBCA 不需要初始化普通 CA 的 WebSocket
                    return
                }

                // 初始化WebSocket连接
                await this.xtxObject.initWebSocket()
                await this.refreshCertList()
                if (this.certList.length > 0) {
                    // 自动选择第一个证书
                    const selectedCert = this.certList[0]
                    this.loginForm.username = selectedCert.certid
                } else {
                    this.$message.warning('未找到可用证书，请确保已插入CA锁并安装了证书助手')
                }
            } catch (error) {
                console.error('请确保已安装证书助手并插入CA锁')
            }
        },
        // 获取选择的证书ID
        getSelectCertID() {
            if (!this.loginForm.username || this.loginForm.username === '') {
                this.$message.warning('请选择证书')
                return ''
            }
            return this.loginForm.username
        },

        // 添加开标记录
        async addOpeningRecord() {
            try {
                const res = await addOpeningRecord({
                    sectionCode: this.sectionCode,
                })
                if (res.code === 200) {
                    this.getOpeningList()
                } else if (res.code == 9044) {
                    this.$message.error(res.msg)
                    setTimeout(() => {
                        this.$router.go(-1)
                    }, 2500);
                }
                else {
                    this.$message.error(res.msg || '添加开标记录失败')
                }
            } catch (e) {
                this.$message.error('添加开标记录失败')
            }
        },
        // 获取开标列表
        async getOpeningList() {
            this.tableLoading = true

            try {
                const res = await getOpeningListForBidder({
                    sectionCode: this.sectionCode,
                    envelopeCode: this.envelopeCode
                })
                if (res.code === 200) {
                    console.log('获取开标列表成功:', res.data)

                    // 验证数据格式
                    if (!res.data) {
                        console.warn('接口返回数据为空')
                        this.dynamicTableData = []
                        this.dynamicTableColumns = []
                        return
                    }

                    // 处理数据
                    this.processDynamicTableData(res.data)
                } else {
                    this.handleApiError(res.msg || '获取开标列表失败')
                }
            } catch (error) {
                console.error('获取开标列表异常:', error)
                this.handleApiError('获取开标列表失败', error)
            } finally {
                this.tableLoading = false
            }
        },
        // 处理动态表格数据
        processDynamicTableData(data) {
            if (!data || !data.title || !data.items) {
                console.warn('接口数据格式不正确')
                return
            }

            // 先清空之前的数据，强制表格重新渲染
            this.dynamicTableData = []
            this.dynamicTableColumns = []
            this.originalDynamicTableData = []

            // 使用 $nextTick 确保 DOM 更新完成后再构建数据
            this.$nextTick(() => {
                this._buildTableData(data)
                // 再次使用 $nextTick 确保数据完全渲染
                this.$nextTick(() => {
                    // 强制更新组件
                    this.$forceUpdate()
                })
            })
        },
        // 构建表格数据
        _buildTableData(data) {
            const { title, items } = data
            // 表头排序
            const sortedTitle = [...title].sort((a, b) => {
                const keyA = parseInt(a.key)
                const keyB = parseInt(b.key)
                if (keyA < 0 && keyB < 0) {
                    return keyB - keyA
                }
                if (keyA >= 0 && keyB >= 0) {
                    return keyA - keyB
                }
                if (keyA < 0 && keyB >= 0) return -1
                if (keyA >= 0 && keyB < 0) return 1
                return 0
            })

            this.dynamicTableColumns = [
                ...sortedTitle.map(titleItem => ({
                    prop: `item_${titleItem.key}`,
                    label: titleItem.value,
                    fixed: parseInt(titleItem.key) < 0 ? true : false,
                }))
            ]

            if (this.shouldShowActions) {
                this.dynamicTableColumns.push({
                    prop: 'actions',
                    label: '操作',
                    fixed: 'right',
                    width: 150
                })
            }

            const bidderMap = new Map()
            items.forEach((row, index) => {
                const children = Array.isArray(row.child) ? row.child : []
                const bidderCell = children.find(c => String(c.itemKey) === '-2' && c.itemValue)
                const hasBidderCell = bidderCell && bidderCell.itemValue && bidderCell.itemValue.trim()
                const hasRowBidderName = row.bidderName && row.bidderName.trim()
                if (!hasBidderCell && !hasRowBidderName) {
                    console.log(`跳过第${index}行: 无投标人信息`)
                    return
                }
                const bidderId = (bidderCell && bidderCell.userId) || row.userId || row.bidOpeningGuid || `bidder_${index}`
                const bidderName = (bidderCell && bidderCell.itemValue) || row.bidderName || ''
                const bidOpeningGuid = (bidderCell && bidderCell.bidOpeningGuid) || row.bidOpeningGuid || ''

                if (!bidderMap.has(bidderId)) {
                    bidderMap.set(bidderId, {
                        bidderName,
                        bidOpeningGuid,
                        bidSectionCode: row.bidSectionCode,
                        decryptStatus: row.decryptStatus || 1, // 解密状态 1未解密 2解密成功 3解密失败
                        publishStatus: row.publishStatus || 0,  // 公布状态 0未公布 1公布
                        guarantee: row.guarantee || 0
                    })
                }
                const bidder = bidderMap.get(bidderId)
                // 用 child 里的 itemValue 填充表格单元格
                children.forEach(cell => {
                    if (cell.itemKey == null) return
                    const key = `item_${cell.itemKey}`
                    bidder[key] = cell.itemValue || cell.itemName || ''
                })
                if (row.decryptStatus !== undefined) {
                    bidder.decryptStatus = row.decryptStatus
                }
                if (row.publishStatus !== undefined) {
                    bidder.publishStatus = row.publishStatus
                }
                if (row.guarantee !== undefined) {
                    bidder.guarantee = row.guarantee
                }
            })
            const tableData = Array.from(bidderMap.values())
            this.$set(this, 'originalDynamicTableData', [...tableData])
            this.$set(this, 'dynamicTableData', [...tableData])
            this.tableRefreshKey = Date.now()
        },

        // 打开开标记录弹窗
        handleOpenRecordDialog() {
            this.addRecordDialogVisible = true
            this.getOpeningRecordDetail()
            if (this.roleId == 1) {
                this.getSignNot()
            }
        },
        // 打印开标记录
        handlePrintRecord() {
            const printWindow = window.open('', '_blank')
            const content = `
                <html>
                <head>
                    <title>开标记录</title>
                    <style>
                        body { font-family: "Microsoft YaHei", sans-serif; padding: 40px; color: #333; }
                        h2 { text-align: center; margin-bottom: 30px; }
                        .info-row { margin-bottom: 12px; font-size: 14px; }
                        .info-row label { font-weight: bold; }
                        .content-area { margin-top: 20px; border: 1px solid #eee; padding: 15px; min-height: 100px; }
                        table { width: 100%; border-collapse: collapse; margin-top: 20px; }
                        th, td { border: 1px solid #333; padding: 8px 12px; text-align: center; font-size: 13px; }
                        th { background: #f5f5f5; }
                        @media print { body { padding: 20px; } }
                    </style>
                </head>
                <body>
                    <div class="content-area">${this.recordForm.content || ''}</div>
                </body>
                </html>
            `
            printWindow.document.write(content)
            printWindow.document.close()
            printWindow.onload = () => {
                printWindow.print()
            }
        },
        // 保存草稿
        handleSaveDraft(type) {
            this.$refs.recordFormRef.validate((valid) => {
                if (valid) {
                    this.getOpeningRecord(type)
                } else {
                    this.$message.error('请完善必填信息')
                    return false
                }
            })
        },
        // 提交开标记录
        getOpeningRecord(type) {
            getOpeningRecord({
                bidOpeningTime: timeUtils.formatTime(this.recordForm.bidOpeningTime),
                bidSectionCode: this.recordForm.bidSectionCode,
                content: this.recordForm.content,
                participants: this.recordForm.participants,
                submitType: type
            }).then(res => {
                if (res.code === 200) {
                    setTimeout(() => {
                        this.addRecordDialogVisible = false
                    }, 500);
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        // 签名确认
        handleSign() {
            this.$confirm('确认签名后将无法修改，是否继续？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.signNot()
            }).catch(() => {
                this.$message.info('已取消签名')
            })
        },
        // 投标人签字
        signNot() {
            signNot(this.sectionCode).then(res => {
                if (res.code === 200 && res.data) {
                    this.$message.success('签名成功')
                    this.getSignNot()
                    this.getOpeningRecordDetail()
                }
            }).catch(() => {
                this.$message.error('投标人签字失败')
            })
        },
        // 查询投标人是否签字
        getSignNot() {
            getSignNot(this.sectionCode).then(res => {
                if (res.code === 200) {
                    this.signed = res.data == 1
                } else {
                    this.$message.error(res.msg)
                }
            }).catch(() => {
                this.$message.error('查询投标人是否签字失败')
            })
        },
        // 清洗开标记录富文本:
        // 1) 移除接口返回中的非法/无效标签(如 <tdead>),避免渲染成空白方块
        // 2) 把 ISO 时间里的 'T' 分隔符替换为空格,例如 2026-08-11T09:14:49 -> 2026-08-11 09:14:49
        cleanRecordContent(html) {
            if (!html || typeof html !== 'string') return html || ''
            let cleaned = html
            // 移除 <tdead ...></tdead> 这种无效标签(包括带属性的)
            cleaned = cleaned.replace(/<tdead\b[^>]*>[\s\S]*?<\/tdead>/gi, '')
            cleaned = cleaned.replace(/<tdead\b[^>]*\/?>/gi, '')
            // 把时间中的 T 替换成空格 (匹配 YYYY-MM-DDTHH:MM:SS 形式,带可选毫秒和时区)
            cleaned = cleaned.replace(
                /(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?(?:Z|[+\-]\d{2}:?\d{2})?)/g,
                '$1 $2'
            )
            return cleaned
        },
        //获取开标记录接口
        getOpeningRecordDetail() {
            getOpeningRecordDetail(this.sectionCode, this.envelopeCode).then(res => {
                if (res.code === 200) {
                    // 设置提交状态
                    this.submitType = res.data.submitType || 0
                    this.recordForm = {
                        bidSectionCode: res.data.bidSectionCode || this.sectionCode,
                        participants: res.data.participants || '',
                        bidOpeningTime: res.data.bidOpeningTime || this.openingTime,
                        content: this.cleanRecordContent(res.data.content || ''),
                        list: res.data.list || []
                    }
                } else {
                    // 接口失败时，设置为可编辑状态
                    this.submitType = 0
                    this.recordForm = {
                        bidSectionCode: this.sectionCode,
                        participants: '',
                        bidOpeningTime: '',
                        content: '',
                        list: []
                    }
                    this.$message.error(res.msg)
                }
            }).catch(() => {
                // 请求异常时，设置为可编辑状态
                this.submitType = 0
                this.recordForm = {
                    bidSectionCode: this.sectionCode,
                    participants: '',
                    bidOpeningTime: '',
                    content: '',
                    list: []
                }
            })
        },
        // 更新时间显示
        updateTime() {
            try {
                const base = (this.serverNowMs && !isNaN(this.serverNowMs)) ? new Date(this.serverNowMs) : new Date()
                const hours = base.getHours().toString().padStart(2, '0')
                const minutes = base.getMinutes().toString().padStart(2, '0')
                const seconds = base.getSeconds().toString().padStart(2, '0')
                this.currentTime = `${hours}:${minutes}:${seconds}`
                const weekdays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
                const year = base.getFullYear()
                const month = (base.getMonth() + 1).toString().padStart(2, '0')
                const day = base.getDate().toString().padStart(2, '0')
                const weekday = weekdays[base.getDay()]
                this.currentDate = ` ${year}-${month}-${day}`
                const openingDate = this.parseMaskDateTime(this.openingTime)
                if (this.showBidderMask && this.isBidder && openingDate && base.getTime() >= openingDate.getTime()) {
                    this.showBidderMask = false
                }
            } catch (error) {
                console.error('更新时间失败:', error)
            }
        },
        // 投标人进入大厅：先检查是否满足进入条件，满足条件（res.code === 200）才发送"进入大厅"消息
        async handleBidderEnterHall() {
            try {
                const res = await getOpeningIsMeet(this.sectionCode)
                if (res && res.code === 200) {
                    this.newMessage = "进入大厅"
                    this.sendMessage()
                }
            } catch (err) {
                console.error('handleBidderEnterHall error', err)
            }
        },
        // 发送消息
        sendMessage() {
            if (!this.newMessage.trim()) return
            try {
                const now = new Date()
                const time = now.toTimeString().slice(0, 8)
                this.messages.push({
                    time: time,
                    type: '用户',
                    content: this.newMessage
                })
            } catch (error) {
                console.error('发送消息失败:', error)
                this.$message.error('发送消息失败')
            }
        },
        //  聊天发消息

        sendMessage() {
            sendMessage({
                groupId: this.processInfo.topic,
                msg: this.newMessage,
                userName: Cookies.get('userName'),
                msgType: 1
            }).then(res => {
                if (res.code === 200) {
                    this.newMessage = ''
                } else {
                    this.$message.error(res.msg)
                }
            })

        },
        // 滚动到底部
        scrollToBottom() {
            this.$nextTick(() => {
                const messageList = this.$refs.messageList
                if (messageList) {
                    messageList.scrollTop = messageList.scrollHeight
                }
            })
        },

        // ==================== 开标操作 ====================

        // 开启开标保障确认 (招标代理专用)
        confirmStartBidGuarantee(row) {
            this.$confirm('是否开启开标保障', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.doStartBidGuarantee(row)
            }).catch(() => { })
        },
        // 执行开启开标保障
        doStartBidGuarantee(row) {
            startBidGuarantee(row.bidOpeningGuid).then(res => {
                if (res.code === 200) {
                    this.$message.success('开启开标保障成功')
                    this.getOpeningList()
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        // 公布开标内容 (投标人专用)
        async publishBidContent(row) {
            const caType = this.$channelMaterial.getCaType()
            this.bidOpeningGuid = row.bidOpeningGuid
            if (row.decryptStatus == 2) {
                return;
            }
            this.guarantee = row.guarantee;
            this.currentDecryptBidderName = row.bidderName || ''

            if (caType === 'HBCA') {
                if (row.guarantee == 1) {
                    this.bidKey = ''
                    this.resetGuaranteeStep()
                    this.guaranteeDialogVisible = true
                } else {
                    // 河北CA解密流程
                    this.hbcaDialogVisible = true
                    await this.handleHbcaInit()
                }
            } else {
                // 其他CA（原有流程）
                if (row.guarantee == 1) {
                    this.bidKey = ''
                    this.resetGuaranteeStep()
                    this.guaranteeDialogVisible = true
                } else {
                    if (!this.certList || !this.certList.length) {
                        await this.initCertList()
                    }
                    this.resetUnlockStep()
                    this.loginDialogVisible = true
                }
            }
        },

        // ========== 河北CA (HBCA) 解密流程 ==========

        // 初始化河北CA控件
        async handleHbcaInit() {
            const hbca = this._hbcaComposable
            if (!hbca) return
            this.hbcaError = ''
            try {
                await hbca.initCA()
            } catch (err) {
                console.error('[河北CA] 初始化失败:', err)
                this.hbcaError = err.message || '河北CA初始化失败'
                this.$message.error('河北CA初始化失败：' + (err.message || err))
            }
        },

        // 关闭河北CA遮挡层
        handleCloseHbcaOverlay() {
            this.hbcaDialogVisible = false
            this.hbcaError = ''
            this.resetUnlockStep()
        },

        // 河北CA解密
        async handleHbcaDecrypt() {
            const hbca = this._hbcaComposable
            if (!hbca) return
            if (!this.bidKey) {
                await this.getBidKey()
                if (!this.bidKey) {
                    this.$message.warning('未获取到加密密钥')
                    return
                }
            }
            this.hbcaLoginLoading = true
            this.hbcaError = ''
            this.unlockStepText = '正在调用数字证书...'
            this.unlockStepStatus = 'loading'
            try {
                const hebcaClient = hbca.getHebcaClient()
                if (!hebcaClient) {
                    throw new Error('CA 控件未初始化，请刷新页面重试')
                }
                this.unlockStepText = '请在弹出的证书选择框中选择用于解密的数字证书...'
                const plainKey = await new Promise((resolve, reject) => {
                    hebcaClient.p7UnEnvelop({
                        pkcs7: this.bidKey,
                        success: (data) => resolve(data),
                        fail: (e) => reject(new Error(e?.message || e?.toString() || String(e)))
                    })
                })
                if (!plainKey) {
                    throw new Error('解密结果为空，请确认选择了正确的证书')
                }
                this.unlockStepText = '解密成功'
                this.unlockStepStatus = 'success'
                this.handleDecrypt(plainKey, 'hbca')
            } catch (err) {
                console.error('[河北CA] 解密失败:', err)
                const msg = err.message || String(err)
                this.hbcaError = msg
                this.unlockStepStatus = 'error'
                this.unlockStepText = '解密失败：' + msg
                this.$message.error('河北CA解密失败：' + msg)
            } finally {
                this.hbcaLoginLoading = false
            }
        },

        // 设置解锁步骤状态
        setUnlockStep(status, text) {
            this.unlockStepStatus = status || 'idle'
            this.unlockStepText = text || ''
        },
        resetUnlockStep() {
            this.unlockStepStatus = 'idle'
            this.unlockStepText = ''
        },

        // 在遮挡层中点击用户项，仅切换选择（不自动登录）
        handleSelectCAUser(cert) {
            if (!cert) return
            this.loginForm.username = cert.certid
        },

        // 刷新证书列表
        async handleRefreshCertList() {
            this.certRefreshLoading = true
            try {
                await this.refreshCertList({ clearSelection: false })
                this.$message.success('证书列表已刷新')
            } catch (error) {
                console.error('刷新证书列表失败:', error)
                this.$message.error('刷新证书列表失败：请确认已插入 CA 锁并安装证书助手')
            } finally {
                this.certRefreshLoading = false
            }
        },

        // CA 登出
        async handleCALogout() {
            this.caLogoutLoading = true
            try {
                await this.xtxObject.initWebSocket()
                // 登出实际登录的证书容器，后退为默认容器
                const logoutCertId = this.loginForm.username || this.defaultCaCertId
                await this.xtxObject.SOF_Logout(logoutCertId)
                this.caLoggedIn = false
                this.bidKey = ''
                this.setUnlockStep('idle', 'CA 已退出登录')
                this.$message.success('CA 已退出登录')
            } catch (error) {
                console.error('CA 登出失败:', error)
                this.$message.error('CA 登出失败：' + (error.message || '未知错误'))
            } finally {
                this.caLogoutLoading = false
            }
        },

        // 关闭 CA 登录遮挡层
        handleCloseLoginOverlay() {
            this.loginDialogVisible = false
            this.resetUnlockStep()
        },

        //  获取密钥
        async getBidKey() {
            const res = await getBidKeyInfo(this.sectionCode)
            if (res.code === 200) {
                // 存储加密的 secretKey 以及完整加密信息
                this.bidKeyInfo = res.data || null
                this.bidKey = (res.data && res.data.secretKey) || ''
                console.log('获取密钥成功，密钥长度:', this.bidKey ? this.bidKey.length : 0)
            } else {
                this.bidKeyInfo = null
                this.$message.error(res.msg)
            }
        },

        // 检查CA登录状态
        async checkCALoginStatus(showMessage = true) {
            try {
                await this.xtxObject.initWebSocket()
                // 优先查询实际选中的证书容器；未选时退为默认容器
                const checkCertId = this.loginForm.username || this.defaultCaCertId
                const result = await this.xtxObject.SOF_IsLogin(checkCertId)
                const loggedIn = result === true || result === 'true'
                this.caLoggedIn = loggedIn
                if (loggedIn && showMessage) {
                    this.$message.success('CA已登录')
                }
                return loggedIn
            } catch (error) {
                console.error('检查CA登录状态失败:', error)
                this.caLoggedIn = false
                return false
            }
        },

        // CA切换（先登出当前账户，再使用当前选中的用户重新登录，并继续解密流程）
        async handleCASwitch() {
            if (!this.loginForm.username) {
                this.$message.warning('请先选择要切换的CA用户')
                return
            }
            this.caSwitchLoading = true
            try {
                const targetCertId = this.loginForm.username
                this.setUnlockStep('loading', '切换 CA 用户中...')
                // 先登出当前已登录的证书容器
                await this.xtxObject.initWebSocket()
                await this.xtxObject.SOF_Logout(targetCertId)
                this.caLoggedIn = false
                // 清空密钥
                this.bidKey = ''
                // 重新登录（固定使用默认密码 111111）
                const result = await this.xtxObject.SOF_Login(targetCertId, '111111')
                if (this.isXtxLoginSuccess(result)) {
                    this.caLoggedIn = true
                    this.setUnlockStep('success', 'CA 切换登录成功')
                    this.$message.success('CA切换成功')
                    // 切换后重新获取密钥并继续解密流程
                    await this.getBidKey()
                    this.handleAsymDecrypt()
                } else {
                    this.setUnlockStep('error', 'CA 切换登录失败')
                    this.$message.error('CA切换登录失败')
                }
            } catch (error) {
                console.error('切换CA失败:', error)
                this.setUnlockStep('error', '切换 CA 失败：' + (error.message || '未知错误'))
                this.$message.error('切换CA失败：' + (error.message || '未知错误'))
            } finally {
                this.caSwitchLoading = false
            }
        },

        // 登录
        async handleLoginSubmit() {






            if (!this.loginForm.username) {
                this.$message.warning('请选择 CA 账号')
                return
            }
            this.loginLoading = true
            let shouldCloseOverlay = true
            const certId = this.getSelectCertID()
            if (!certId) {
                this.loginLoading = false
                return
            }
            try {
                this.setUnlockStep('loading', 'CA 登录中...')
                const result = await this.xtxObject.SOF_Login(certId, '111111')

                const onlyOneMobileCert =
                    !this.mobileCertPreLoginDone &&
                    Array.isArray(this.certList) &&
                    this.certList.length === 1 &&
                    this.isMobileCert(this.certList[0])

                if (this.isXtxLoginSuccess(result)) {
                    this.$message.success('登录成功')
                    this.caLoggedIn = true
                    this.setUnlockStep('success', 'CA 登录成功')

                    if (onlyOneMobileCert) {
                        this.mobileCertPreLoginDone = true
                        await this.refreshCertList({ clearSelection: true })
                        this.$message.info('请重新选择证书后再次登录')
                        shouldCloseOverlay = false
                        this.setUnlockStep('loading', '请重新选择证书后再次登录')
                        return
                    }

                    // 未开启开标保障，直接使用CA解密
                    this.handleAsymDecrypt();
                } else {
                    this.setUnlockStep('error', 'CA 登录失败')
                    this.$message.error('登录失败')
                    shouldCloseOverlay = false
                }
            } catch (error) {
                this.setUnlockStep('error', '登录失败：' + (error.message || '未知错误'))
                this.$message.error('登录失败：' + (error.message || '未知错误'))
                shouldCloseOverlay = false
            } finally {
                this.loginLoading = false
                // 登录成功会继续走到 handleAsymDecrypt，由解密流程在成功后自动关闭遮挡层；
                // 这里不立即关闭，避免中断用户对 step 指示的观察。
                if (!shouldCloseOverlay) {
                    // 保留遮挡层，用户可重试或切换
                }
            }

        },
        // 开标保障弹窗取消按钮
        handleGuaranteeCancel() {
            if (this.guaranteeSubmitting) return
            this.guaranteeDialogVisible = false
            this.resetGuaranteeStep()
            this.bidKey = ''
        },
        // 重置开标保障步骤状态
        resetGuaranteeStep() {
            this.guaranteeStepStatus = 'idle'
            this.guaranteeStepText = ''
        },
        // 开标保障弹窗确定按钮
        async handleGuaranteeSubmit() {
            if (this.guaranteeSubmitting) return
            if (!this.bidKey) {
                this.$message.warning('请输入秘钥')
                return
            }
            this.guaranteeSubmitting = true
            // 已开启开标保障，用户手动输入秘钥，直接调用解密接口
            try {
                // 1. 秘钥校验
                this.setGuaranteeStep('loading', '正在校验秘钥...')
                await new Promise(r => setTimeout(r, 350))

                // 2. 调解密接口
                this.setGuaranteeStep('loading', '正在解密...')
                const res = await decryptOpening({
                    key: this.bidKey,
                    openingRecordGuid: this.bidOpeningGuid,
                    sectionCode: this.sectionCode
                })

                if (res && res.code === 200) {
                    this.setGuaranteeStep('success', '解密成功')
                    this.$message.success('解密成功')
                    this.getOpeningList()
                    // 成功后短暂展示动画，再关闭弹窗
                    setTimeout(() => {
                        this.guaranteeDialogVisible = false
                        this.guaranteeSubmitting = false
                        this.resetGuaranteeStep()
                        this.bidKey = ''
                    }, 600)
                } else {
                    this.setGuaranteeStep('error', (res && res.msg) || '解密失败，请检查秘钥是否正确')
                    this.$message.error((res && res.msg) || '解密失败')
                    this.guaranteeSubmitting = false
                }
            } catch (error) {
                this.setGuaranteeStep('error', '解密失败：' + ((error && error.message) || '未知错误'))
                this.$message.error('解密失败：' + ((error && error.message) || '未知错误'))
                this.guaranteeSubmitting = false
            }
        },
        setGuaranteeStep(status, text) {
            this.guaranteeStepStatus = status || 'idle'
            this.guaranteeStepText = text || ''
        },
        // 对密钥进行CA解密
        async handleAsymDecrypt() {
            const certId = this.getSelectCertID()
            if (!certId) return
            if (!this.bidKey) {
                this.setUnlockStep('error', '未获取到加密密钥')
                this.$message.warning('请先输入或生成加密后的密文')
                return
            }
            // 解密前校验当前 CA 是否与加密时使用的锁信息一致
            const lockCertId = this.bidKeyInfo && (this.bidKeyInfo.caKeyId || this.bidKeyInfo.cakeyId)
            const lockCertName = this.bidKeyInfo && this.bidKeyInfo.caKeyName
            if (lockCertId && lockCertId !== certId) {
                const currentName = this.currentSelectedCAName || certId
                this.setUnlockStep('error', `当前 CA(${currentName}) 与加密时锁证书(${lockCertName || lockCertId})不一致`)
                this.$message.error('当前选中的 CA 与加密时使用的不一致，请选择与锁信息匹配的证书')
                return
            }
            try {
                this.setUnlockStep('loading', '私钥解密中...')
                const plain = await this.xtxObject.SOF_PriKeyDecrypt(certId, this.bidKey)
                if (!plain) {
                    this.setUnlockStep('error', '私钥解密失败，请确认当前锁介质（单位锁/个人锁）与投标时使用的是同一个')
                    this.$message.error('私钥解密失败：请确认使用与投标时同一介质的 CA 锁')
                    return
                }
                // 解密成功后直接调用解密接口
                this.handleDecrypt(plain)
            } catch (error) {
                console.error('私钥解密错误:', error)
                this.setUnlockStep('error', '私钥解密失败：' + (error.message || '未知错误'))
                this.$message.error('私钥解密失败：' + (error.message || '未知错误'))
            }
        },
        // 解密接口
        async handleDecrypt(decryptedKey, source = 'xtx') {
            this.setUnlockStep('loading', '正在解密...')
            decryptOpening({
                key: decryptedKey,
                openingRecordGuid: this.bidOpeningGuid,
                sectionCode: this.sectionCode
            }).then(res => {
                if (res.code === 200) {
                    this.setUnlockStep('success', '解密成功')
                    this.$message.success('解密成功')
                    // 解密完成后自动关闭遮挡层
                    setTimeout(() => {
                        if (source === 'hbca') {
                            this.hbcaDialogVisible = false
                        } else {
                            this.loginDialogVisible = false
                        }
                        this.resetUnlockStep()
                    }, 600)
                    this.getOpeningList()
                } else {
                    this.setUnlockStep('error', res.msg || '解密失败')
                    this.$message.error(res.msg)
                }
            }).catch(error => {
                this.setUnlockStep('error', '解密失败：' + ((error && error.message) || '未知错误'))
            })
        },
        // 公布开标内容 (招标代理专用)
        publishContent(row) {
            this.$confirm('是否公布开标内容', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.publish(row)
            }).catch(() => { })

        },
        publish(row) {
            publish(row.bidOpeningGuid).then(res => {
                if (res.code === 200) {
                    this.$message.success('所有已解密的内容公布成功')
                    this.getOpeningList()
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        // ==================== UI 交互 ====================

        // 切换下拉框显示
        toggleDropdown() {
            this.isDropdownOpen = !this.isDropdownOpen
        },
        // 选择项目
        selectProject(project) {
            this.currentProjectId = project.id
            this.projectName = project.name
            this.isDropdownOpen = false
            this.updateProjectInfo(project)
            // 更新当前标段编码并重新拉取数据
            if (project.bidSectionCode) {
                this.sectionCode = project.bidSectionCode
            } else if (project.id) {
                this.sectionCode = project.id
            }
            this.initHttp()
        },
        // 更新项目信息
        updateProjectInfo(project) {
            // 根据项目状态更新当前状态
            switch (project.status) {
                case 'active':
                    this.currentStatus = '评标进行中'
                    break
                case 'pending':
                    this.currentStatus = '等待开始'
                    break
                case 'completed':
                    this.currentStatus = '评标结束'
                    break
            }
            // 这里可以根据项目ID加载对应的数据
            this.loadProjectData(project.id)
        },
        // 加载项目数据
        loadProjectData(projectId) {
            console.log('加载项目数据:', projectId)
        },
        // 处理点击外部关闭下拉框
        handleClickOutside(event) {
            const dropdown = this.$el.querySelector('.project-dropdown')
            const bidStatus = this.$el.querySelector('.bid-status')
            if (dropdown && bidStatus && !bidStatus.contains(event.target) && !dropdown.contains(event.target)) {
                this.isDropdownOpen = false
            }
        },
        // ==================== 分页与资源管理 ====================

        // 分页大小变更
        handleSizeChange(val) {
            this.pagination.pageSize = val
            this.loadData()
        },
        // 分页切换
        handleCurrentChange(val) {
            this.pagination.currentPage = val
            this.loadData()
        },
        // 统一资源清理
        cleanup() {
            this.clearTimeTimer()
            document.removeEventListener('click', this.handleClickOutside)
            // 清理CA相关资源
            if (this.xtxObject) {
                try {
                    this.xtxObject.closeWebSocket && this.xtxObject.closeWebSocket()
                } catch (error) {
                    console.warn('清理CA资源失败:', error)
                }
            }
        },
        formatDateTime(date) {
            const d = new Date(date);
            const f = (n) => (n < 10 ? '0' : '') + n;
            return `${f(d.getMonth() + 1)}月${f(d.getDate())}日 ${f(d.getHours())}:${f(d.getMinutes())}:${f(d.getSeconds())}`;
        },
        // 一键公开
        handleOpen() {

            this.$confirm('是否要公开所有的开标内容？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.publishAll()
            }).catch(() => { })


        },
        publishAll() {
            publishAll(this.sectionCode, this.envelopeCode).then(res => {
                if (res.code === 200) {
                    this.getOpeningList()
                } else {
                    this.$message.error(res.msg)
                }
            })

        },
        handleExitHall() {
            this.$router.go(-1)
        }

    },

    // 组件销毁前清理资源
    beforeDestroy() {
        this.stopTts()
        this.stopChatTimer()
        this.stopOpeningDecryptInfoTimer()
        this.stopMqttReconnectTimer()
        this.cleanup()
        // MQTT.disconnect()
        EventBus.$off('question-challenge-received')
    },

    // 组件销毁时确保清理
    destroyed() {
        this.stopTts()
        this.stopMqttReconnectTimer()
        this.cleanup()
        // MQTT.disconnect()
    }
}
</script>

<style lang="less" scoped>
:root {
    --primary-color: #1976d2;
    --success-color: #67c23a;
    --warning-color: #e6a23c;
    --danger-color: #f56c6c;
    --info-color: #909399;
    --border-radius: 15px;
    --border-radius-small: 6px;
    --box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    --box-shadow-large: 0 4px 20px rgba(0, 0, 0, 0.15);
    --transition: all 0.3s ease;
}

// 电子唱标高亮行
::v-deep .tts-highlight-row {
    background-color: #e6f7ff !important;

    td {
        background-color: #e6f7ff !important;
    }
}

.open-hall {
    position: relative;
    width: 100%;
    height: 100vh;
    background-image: url('../../../assets/image/openHallbg.jpg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    padding: 5vw;
    box-sizing: border-box;

    .bidder-mask-overlay {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 9998;
        background-image: url('../../../assets/image/openHallbg.jpg');
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;

        .mask-exit-wrapper {
            position: absolute;
            top: 34px;
            right: 42px;
            z-index: 2;

            .mask-exit-btn {
                min-width: 100px;
                height: 46px;
                border-radius: 18px;
                border: 1px solid rgba(184, 116, 67, 0.45);
                background: linear-gradient(180deg, #fffdf7 0%, #f8f1df 100%);
                box-shadow: 0 8px 18px rgba(76, 39, 18, 0.18);
                color: #9e4527;
                font-size: 16px;
                font-weight: 700;

                &:hover,
                &:focus {
                    color: #8a3419;
                    border-color: rgba(184, 116, 67, 0.6);
                    background: linear-gradient(180deg, #fffefb 0%, #f6e8cb 100%);
                }
            }
        }

        .content-view {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            gap: 28px;

            .mask-logo {
                width: 180px;
                height: 180px;
                object-fit: contain;
            }

            .mask-time-card {
                width: min(560px);
                padding: 30px 34px;
                border-radius: 24px;
                background: rgba(255, 255, 255, 0.9);
                backdrop-filter: blur(10px);
                box-shadow: 0 18px 45px rgba(0, 0, 0, 0.16);
                border: 1px solid rgba(255, 255, 255, 0.55);

                .mask-time-card__title {
                    text-align: center;
                    font-size: 24px;
                    font-weight: 700;
                    color: #1f2d3d;
                    margin-bottom: 24px;
                    letter-spacing: 1px;
                    line-height: 1.35;
                    word-break: break-word;
                    overflow-wrap: anywhere;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                }

                .mask-time-grid {
                    display: flex;
                    align-items: center;
                    // display: grid;
                    // grid-template-columns: repeat(3, minmax(0, 1fr));
                    // gap: 18px;
                }

                .mask-time-item {
                    padding: 22px 18px;
                    border-radius: 18px;
                    background: linear-gradient(135deg, rgba(25, 118, 210, 0.92) 0%, rgba(64, 158, 255, 0.9) 100%);

                    text-align: center;
                    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.8);

                    &.mask-time-item--highlight {

                        background: linear-gradient(180deg, rgba(245, 247, 250, 0.95) 0%, rgba(232, 237, 245, 0.92) 100%);

                        .mask-time-item__label,
                        .mask-time-item__value {
                            color: black;
                        }
                    }

                    .mask-time-item__label {
                        font-size: 14px;
                        color: white;
                        margin-bottom: 12px;
                        letter-spacing: 1px;
                    }

                    .mask-time-item__value {
                        font-size: 22px;
                        line-height: 1.6;
                        font-weight: 700;
                        color: white;
                        word-break: break-word;
                    }
                }
            }
        }
    }

    .open-hall-content {
        display: flex;
        flex-direction: column;
        background: white;
        width: 100%;
        height: 100%;
        box-shadow: var(--box-shadow);
        border-radius: var(--border-radius);
    }

    // 顶部导航栏
    .top-navbar {
        height: 60px;
        background: var(--primary-color);
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 20px;
        color: white;
        border-top-left-radius: var(--border-radius);
        border-top-right-radius: var(--border-radius);

        .navbar-left {
            display: flex;
            align-items: center;
            gap: 12px;

            .back-btn {
                border-color: rgba(255, 255, 255, 0.6);
                background: rgba(255, 255, 255, 0.15);
                color: #fff;
                font-size: 12px;
                padding: 6px 12px;
                transition: background 0.2s;

                &:hover,
                &:focus {
                    background: rgba(255, 255, 255, 0.28);
                    border-color: rgba(255, 255, 255, 0.8);
                    color: #fff;
                }
            }

            .logo {
                display: flex;
                align-items: center;
                gap: 14px;

                .logo-text {
                    font-size: 18px;
                    font-weight: bold;
                }

                .tts-controls {
                    display: flex;
                    align-items: center;
                    gap: 6px;

                    .tts-btn {
                        border-color: rgba(255, 255, 255, 0.6);
                        background: rgba(255, 255, 255, 0.15);
                        color: #fff;
                        font-size: 12px;
                        padding: 4px 10px;
                        transition: background 0.2s;

                        &:hover {
                            background: rgba(255, 255, 255, 0.28);
                        }

                        &.tts-btn--pause {
                            border-color: rgba(255, 255, 255, 0.5);
                            background: rgba(255, 255, 255, 0.1);
                        }

                        &.el-button--danger {
                            border-color: rgba(255, 100, 100, 0.7);
                            background: rgba(255, 80, 80, 0.25);
                            color: #ffd0d0;
                        }
                    }
                }
            }
        }

        .navbar-center {
            position: relative;

            .bid-status {
                display: flex;
                align-items: center;
                gap: 10px;
                cursor: pointer;
                padding: 8px 16px;
                border-radius: 20px;
                transition: var(--transition);

                .status-label {
                    color: #ff4444;
                    font-size: 22px;
                    font-weight: 800;
                }

                .project-name {
                    color: white;
                    font-size: 18px;
                }

                i {
                    color: white;
                    transition: var(--transition);

                    &.rotate {
                        transform: rotate(90deg);
                    }
                }

                // 激活状态样式
                &.active {
                    background: linear-gradient(135deg, #4CAF50, #45a049);
                    box-shadow: 0 4px 15px rgba(76, 175, 80, 0.3);

                    .status-label {
                        color: #fff;
                    }

                    .project-name {
                        color: #fff;
                    }
                }
            }

            // 下拉框样式
            .project-dropdown {
                position: absolute;
                top: 100%;
                left: 0;
                right: 0;
                background: rgba(255, 255, 255, 0.95);
                border-radius: 8px;
                box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
                z-index: 1000;
                margin-top: 8px;
                max-height: 300px;
                overflow-y: auto;

                .dropdown-list {
                    .dropdown-item {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        padding: 12px 16px;
                        cursor: pointer;
                        transition: var(--transition);
                        border-bottom: 1px solid rgba(0, 0, 0, 0.05);

                        &:hover {
                            background: rgba(64, 158, 255, 0.1);
                        }

                        &.active {
                            background: rgba(64, 158, 255, 0.2);
                            border-left: 3px solid #409eff;
                        }

                        &:last-child {
                            border-bottom: none;
                        }

                        .project-title {
                            color: #333;
                            font-size: 14px;
                            font-weight: 500;
                            flex: 1;
                            margin-right: 12px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }

                        .project-status {
                            font-size: 12px;
                            padding: 2px 8px;
                            border-radius: 12px;
                            font-weight: 500;

                            &.active {
                                background: rgba(103, 194, 58, 0.1);
                                color: #67c23a;
                            }

                            &.pending {
                                background: rgba(230, 162, 60, 0.1);
                                color: #e6a23c;
                            }

                            &.completed {
                                background: rgba(144, 147, 153, 0.1);
                                color: #909399;
                            }
                        }
                    }
                }
            }
        }

        .navbar-right {
            .search-box {
                display: flex;
                align-items: center;
                gap: 10px;
            }
        }
    }

    // 主要内容区域
    .main-content {
        flex: 1;
        display: flex;
        padding: 20px;
        gap: 20px;
        overflow: hidden;
        border-radius: 20px;
        min-width: 0;
        min-height: 0;

        // 左侧面板
        .left-panel {
            width: 320px;
            min-width: 280px;
            flex-shrink: 0;
            display: flex;
            flex-direction: column;
            gap: 15px;

            .status-card,
            .time-card,
            .deadline-card,
            .process-card {
                background: white;
                border: 1px solid #e0e0e0;
                border-radius: 6px;
                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
                display: flex;
                flex-direction: column;

                .card-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 5px 16px;
                    background: #f8f9fa;
                    border-bottom: 1px solid #e0e0e0;
                    border-radius: 6px 6px 0 0;

                    .card-title {
                        font-weight: 600;
                        color: #333;
                        font-size: 14px;
                    }
                }

                .card-content {
                    padding: 8px;
                    flex: 1;
                    display: flex;
                    flex-direction: column;

                    .status-text {
                        color: #ff4444;
                        font-weight: 600;
                        font-size: 16px;
                    }

                    .time-display {
                        .time {
                            color: #ff4444;
                            font-size: 24px;
                            font-weight: bold;
                            display: block;
                            margin-bottom: 8px;
                            font-family: 'Courier New', monospace;
                        }

                        .date {
                            color: #666;
                            font-size: 14px;
                            transition: color 0.3s ease;
                        }
                    }

                    .deadline {
                        color: #333;
                        font-weight: 500;
                        font-size: 16px;
                    }

                    .process-info {
                        margin-bottom: 15px;

                        .process-text {
                            color: #333;
                            font-weight: 500;
                            font-size: 14px;
                        }
                    }

                    .message-list {
                        overflow-y: auto;
                        height: 180px;
                        margin-bottom: 15px;
                        padding: 8px;
                        background: #f8f9fa;
                        border-radius: 4px;
                        border: 1px solid #e0e0e0;

                        .message-item {
                            margin-bottom: 8px;
                            font-size: 13px;
                            line-height: 1.4;

                            .message-time {
                                color: #666;
                                margin-right: 8px;
                            }

                            .message-type {
                                color: #1976d2;
                                margin-right: 8px;
                                font-weight: 500;
                            }

                            .message-content {
                                color: #333;
                            }
                        }
                    }

                    .message-input {
                        display: flex;
                        gap: 10px;
                        margin-top: auto;
                        flex-shrink: 0;

                        .el-input {
                            flex: 1;
                        }
                    }
                }
            }

            .process-card {
                flex: 1;
                min-height: 300px;
                max-height: calc(100vh - 400px);
                overflow: hidden;

                .card-content {
                    overflow: hidden;

                    .message-list {
                        flex: 1;
                        min-height: 100px;
                        max-height: none;
                        height: auto;
                    }

                    .message-input {
                        flex-shrink: 0;
                        padding-top: 10px;
                    }
                }
            }
        }

        // 右侧面板
        .right-panel {
            flex: 1;
            display: flex;
            flex-direction: column;
            min-width: 0;
            overflow: hidden;

            .table-container {
                flex: 1;
                overflow: auto;
                border: 1px solid #e0e0e0;
                border-radius: 4px;
                min-height: 0;

                .el-table {
                    width: 100% !important;
                }
            }

            .button-row {
                display: flex;
                justify-content: space-evenly;
                align-items: center;
                background: white;
                margin-top: 5px;
                border-radius: 0 0 8px 8px;
                padding: 10px 0;

                .button-group {
                    display: flex;
                    gap: 12px;

                    .el-button {
                        padding: 12px 24px;
                        font-weight: 500;
                        border-radius: 6px;
                        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
                    }
                }
            }
        }
    }

    /* 弹窗样式 */
    .add-record-dialog {
        .el-dialog__header {
            background: #f5f5f5;
            padding: 15px 20px;
            border-bottom: 1px solid #e6e6e6;

            .el-dialog__title {
                font-size: 16px;
                font-weight: 500;
            }
        }

        .el-dialog__body {
            padding: 20px;
        }
    }

    // 状态文本样式
    .status-text {
        font-size: 12px;
        padding: 4px 8px;
        border-radius: 4px;
        font-weight: 500;

        &.published {
            background-color: #f0f9ff;
            color: #67c23a;
            border: 1px solid #b3e19d;
        }

        &.decrypt-pending {
            background-color: #fdf6ec;
            color: #e6a23c;
            border: 1px solid #f5dab1;
        }

        &.decrypt-failed {
            background-color: #fef0f0;
            color: #f56c6c;
            border: 1px solid #fbc4c4;
        }

        &.decrypt-success {
            background-color: #f0f9ff;
            color: #67c23a;
            border: 1px solid #b3e19d;
        }

        &.decrypting {
            background-color: #f4f4f5;
            color: #909399;
            border: 1px solid #e9e9eb;
        }
    }
}

// ========== CA 登录遮挡层样式 ==========
.oh-unlock-overlay {
    position: fixed;
    inset: 0;
    z-index: 1999;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    background: rgba(15, 23, 42, 0.72);
    backdrop-filter: blur(4px);
}

.oh-unlock-overlay-card {
    width: 100%;
    max-width: 620px;
    max-height: calc(100vh - 48px);
    padding: 32px;
    border-radius: 20px;
    background: #fff;
    box-shadow: 0 20px 60px rgba(15, 23, 42, 0.28);
    text-align: center;
    overflow-y: auto;
}

.oh-unlock-overlay-icon {
    font-size: 42px;
    margin-bottom: 12px;
}

.oh-unlock-overlay-card h2 {
    margin: 0 0 8px;
    color: #0f172a;
    font-size: 20px;
}

.oh-unlock-overlay-card p {
    margin: 0 0 20px;
    color: #475569;
    font-size: 13px;
}

.oh-unlock-overlay-info {
    margin-bottom: 18px;
    padding: 14px 16px;
    border-radius: 12px;
    background: #f8fafc;
    text-align: left;
}

.oh-unlock-overlay-line {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    margin-bottom: 10px;

    &:last-child {
        margin-bottom: 0;
    }

    span {
        font-size: 12px;
        color: #64748b;
    }

    strong {
        color: #0f172a;
        word-break: break-all;
        text-align: right;

        &.is-ok {
            color: #16a34a;
        }

        &.is-warn {
            color: #d97706;
        }
    }
}

.oh-unlock-overlay-divider {
    height: 1px;
    margin: 12px 0;
    background: #e2e8f0;
}

.oh-unlock-userlist {
    margin-bottom: 16px;
    padding: 12px 14px;
    border-radius: 12px;
    border: 1px solid #e2e8f0;
    background: #fff;
    text-align: left;

    .oh-unlock-userlist__head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 8px;
    }

    .oh-unlock-userlist__title {
        font-size: 13px;
        color: #0f172a;
        font-weight: 600;
    }

    .oh-unlock-userlist__empty {
        padding: 14px 8px;
        font-size: 12px;
        color: #94a3b8;
        text-align: center;
    }

    .oh-unlock-userlist__list {
        list-style: none;
        margin: 0;
        padding: 0;
        max-height: 200px;
        overflow-y: auto;
    }
}

.oh-unlock-user-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 10px 12px;
    margin-bottom: 6px;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    background: #f8fafc;
    cursor: pointer;
    transition: all 0.2s ease;

    &:last-child {
        margin-bottom: 0;
    }

    &:hover {
        border-color: #93c5fd;
        background: #eff6ff;
    }

    &.is-active {
        border-color: #2563eb;
        background: #dbeafe;
    }

    .oh-unlock-user-item__main {
        flex: 1;
        min-width: 0;
        text-align: left;
    }

    .oh-unlock-user-item__name {
        font-size: 13px;
        color: #0f172a;
        font-weight: 600;
        word-break: break-all;
    }

    .oh-unlock-user-item__id {
        margin-top: 2px;
        font-size: 11px;
        color: #64748b;
        word-break: break-all;
    }

    .oh-unlock-user-item__badge {
        flex-shrink: 0;
        padding: 2px 8px;
        font-size: 11px;
        color: #fff;
        background: #16a34a;
        border-radius: 999px;
    }
}

.oh-unlock-ca-select {
    width: 100%;
}

.oh-unlock-overlay-form {
    margin-bottom: 14px;
}

.oh-unlock-step-panel {
    margin-bottom: 18px;
    padding: 12px 14px;
    border-radius: 12px;
    text-align: left;
    background: #f8fafc;

    &.is-loading {
        background: #eff6ff;
    }

    &.is-success {
        background: #ecfdf5;
    }

    &.is-error {
        background: #fef2f2;
    }

    .oh-unlock-step-label {
        display: block;
        margin-bottom: 4px;
        font-size: 12px;
        color: #64748b;
    }

    strong {
        color: #0f172a;
        font-size: 13px;
    }
}

.oh-unlock-overlay-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: center;
}

// ========== 开标保障弹窗解密动画 ==========
.oh-guarantee-step-panel {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 4px;
    margin-bottom: 4px;
    padding: 12px 14px;
    border-radius: 10px;
    text-align: left;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    transition: background-color 0.25s ease, border-color 0.25s ease;

    &.is-loading {
        background: #eff6ff;
        border-color: #bfdbfe;

        .oh-guarantee-step-label {
            color: #2563eb;
        }
    }

    &.is-success {
        background: #ecfdf5;
        border-color: #a7f3d0;

        .oh-guarantee-step-label {
            color: #16a34a;
        }
    }

    &.is-error {
        background: #fef2f2;
        border-color: #fecaca;

        .oh-guarantee-step-label {
            color: #dc2626;
        }
    }
}

.oh-guarantee-step-icon {
    flex-shrink: 0;
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.oh-guarantee-step-body {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.oh-guarantee-step-label {
    font-size: 12px;
    color: #64748b;
    transition: color 0.25s ease;
}

.oh-guarantee-step-panel strong {
    color: #0f172a;
    font-size: 13px;
    word-break: break-all;
}

.oh-guarantee-spinner {
    display: inline-block;
    width: 22px;
    height: 22px;
    border: 3px solid #bfdbfe;
    border-top-color: #2563eb;
    border-radius: 50%;
    box-sizing: border-box;
    animation: oh-guarantee-spin 0.8s linear infinite;
}

@keyframes oh-guarantee-spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

.oh-guarantee-icon-fail-success,
.oh-guarantee-icon-fail-error {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    font-size: 14px;
    font-weight: 700;
    color: #fff;
    animation: oh-guarantee-pop 0.3s ease-out;
}

.oh-guarantee-icon-fail-success {
    background: #16a34a;
}

.oh-guarantee-icon-fail-error {
    background: #dc2626;
}

@keyframes oh-guarantee-pop {
    0% {
        transform: scale(0.5);
        opacity: 0;
    }

    70% {
        transform: scale(1.15);
        opacity: 1;
    }

    100% {
        transform: scale(1);
        opacity: 1;
    }
}

// 只读富文本内容样式
.readonly-rich-content {
    .content-viewer {
        border: 1px solid #dcdfe6;
        border-radius: 4px;
        min-height: 300px;
        padding: 12px;
        background-color: #fafafa;
        font-size: 14px;
        line-height: 1.6;
        color: #606266;

        // 富文本内容样式
        :deep(p) {
            margin: 8px 0;

            &:first-child {
                margin-top: 0;
            }

            &:last-child {
                margin-bottom: 0;
            }
        }

        :deep(h1),
        :deep(h2),
        :deep(h3),
        :deep(h4),
        :deep(h5),
        :deep(h6) {
            margin: 16px 0 8px 0;
            font-weight: 600;

            &:first-child {
                margin-top: 0;
            }
        }

        :deep(ul),
        :deep(ol) {
            margin: 8px 0;
            padding-left: 24px;
        }

        :deep(li) {
            margin: 4px 0;
        }

        :deep(blockquote) {
            margin: 8px 0;
            padding: 8px 16px;
            border-left: 4px solid #dcdfe6;
            background-color: #f5f7fa;
        }

        :deep(table) {
            border-collapse: collapse;
            width: 100%;
            margin: 8px 0;

            th,
            td {
                border: 1px solid #dcdfe6;
                padding: 8px 12px;
                text-align: left;
            }

            th {
                background-color: #f5f7fa;
                font-weight: 600;
            }
        }

        :deep(img) {
            max-width: 100%;
            height: auto;
            margin: 8px 0;
        }

        :deep(code) {
            background-color: #f5f7fa;
            padding: 2px 4px;
            border-radius: 2px;
            font-family: 'Courier New', monospace;
        }

        :deep(pre) {
            background-color: #f5f7fa;
            padding: 12px;
            border-radius: 4px;
            overflow-x: auto;
            margin: 8px 0;

            code {
                background: none;
                padding: 0;
            }
        }
    }
}

// 响应式适配
@media screen and (max-width: 1400px) {
    .open-hall {
        padding: 3vw;

        .main-content {
            .left-panel {
                width: 280px;
                min-width: 250px;
            }

            .right-panel {
                .table-container {
                    .el-table {
                        width: 100% !important;
                    }
                }
            }
        }
    }
}

@media screen and (max-width: 1200px) {
    .open-hall {
        padding: 2vw;

        .main-content {
            gap: 15px;
            padding: 15px;

            .left-panel {
                width: 260px;
                min-width: 220px;
                gap: 10px;

                .process-card {
                    min-height: 250px;
                    max-height: calc(100vh - 350px);

                    .card-content .message-list {
                        height: auto;
                        min-height: 100px;
                        max-height: 140px;
                    }
                }
            }

            .right-panel {
                .table-container {
                    .el-table {
                        width: 100% !important;
                    }
                }
            }
        }

        .top-navbar {
            padding: 0 15px;

            .navbar-center .bid-status {
                padding: 6px 12px;

                .project-name {
                    max-width: 300px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
        }
    }
}

@media screen and (max-width: 992px) {
    .open-hall {
        padding: 1.5vw;

        .main-content {
            flex-direction: column;
            overflow: auto;

            .left-panel {
                width: 100%;
                min-width: unset;
                flex-direction: row;
                flex-wrap: wrap;

                .status-card,
                .time-card,
                .deadline-card {
                    flex: 1;
                    min-width: 200px;
                }

                .process-card {
                    width: 100%;
                    min-height: 200px;
                    max-height: 300px;
                }
            }

            .right-panel {
                min-height: 400px;

                .table-container {
                    .el-table {
                        width: 100% !important;
                    }
                }
            }
        }
    }
}

// 弹幕样式
.barrage-wrapper {
    position: fixed;
    top: 70px;
    left: 0;
    right: 0;
    height: 100px;
    pointer-events: none;
    z-index: 9999;
    overflow: hidden;
}

.barrage-item {
    z-index: 9999;
    position: absolute;
    top: 0;
    white-space: nowrap;
    padding: 6px 16px;
    background: rgba(255, 0, 0, 0.75);
    color: #fff;
    border-radius: 20px;
    font-size: 14px;
    font-weight: bold;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    transition: opacity 0.2s ease;

    @keyframes barrage-move-0 {
        0% {
            left: 100%;
            top: 0px;
        }

        100% {
            left: -300px;
            top: 0px;
        }
    }

    @keyframes barrage-move-1 {
        0% {
            left: 100%;
            top: 20px;
        }

        100% {
            left: -300px;
            top: 20px;
        }
    }

    @keyframes barrage-move-2 {
        0% {
            left: 100%;
            top: 40px;
        }

        100% {
            left: -300px;
            top: 40px;
        }
    }

    @keyframes barrage-move-3 {
        0% {
            left: 100%;
            top: 60px;
        }

        100% {
            left: -300px;
            top: 60px;
        }
    }

    &.barrage-track-0 {
        animation: barrage-move-0 25s linear forwards;
    }

    &.barrage-track-1 {
        animation: barrage-move-1 25s linear forwards;
    }

    &.barrage-track-2 {
        animation: barrage-move-2 25s linear forwards;
    }

    &.barrage-track-3 {
        animation: barrage-move-3 25s linear forwards;
    }
}

// 质疑按钮闪烁动画
.btn-flash {
    animation: btn-flash-anim 0.25s ease-in-out 2;
}

@keyframes btn-flash-anim {

    0%,
    100% {
        opacity: 1;
    }

    50% {
        opacity: 0.3;
    }
}

// 抽取系数弹窗样式
.selection-dialog-body {
    padding: 16px 8px 8px;
    text-align: center;
    min-height: 260px;
}

.selection-section {
    margin-bottom: 20px;
    text-align: left;
}

.selection-section-title {
    font-size: 14px;
    color: #303133;
    font-weight: bold;
    margin-bottom: 12px;
    padding-left: 4px;
    display: flex;
    align-items: center;
    gap: 6px;

    i {
        color: #409eff;
        font-size: 16px;
    }
}

.selection-range-list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    padding: 0 4px;
}

.selection-range-item {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 64px;
    padding: 8px 16px;
    border-radius: 8px;
    background: linear-gradient(135deg, #f5f7fa 0%, #e4e7ed 100%);
    border: 1px solid #e4e7ed;
    color: #606266;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: -100%;
        width: 100%;
        height: 100%;
        background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
        transition: left 0.5s ease;
    }

    &.is-filtering {
        opacity: 0.4;
        transform: scale(0.95);
        background: linear-gradient(135deg, #f4f4f5 0%, #e8e8e8 100%);
    }

    &.is-selected {
        background: linear-gradient(135deg, #409eff 0%, #66b1ff 100%);
        border-color: #409eff;
        color: #fff;
        font-weight: 600;
        transform: scale(1.05);
        box-shadow: 0 4px 12px rgba(64, 158, 255, 0.4);

        &::after {
            content: '✓';
            position: absolute;
            top: -2px;
            right: -2px;
            width: 16px;
            height: 16px;
            background: #67c23a;
            border-radius: 50%;
            font-size: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
        }
    }
}

.selection-result-section {
    text-align: center;
}

.selection-number-wrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 140px;
    padding: 20px 0;
}

.selection-result-card {
    position: relative;
    padding: 20px 40px;
    border-radius: 16px;
    background: linear-gradient(180deg, #f5f7fa 0%, #ffffff 100%);
    border: 2px solid #e4e7ed;
    transition: all 0.4s ease;

    &.is-result {
        background: linear-gradient(180deg, #ecf5ff 0%, #ffffff 100%);
        border-color: #409eff;
        box-shadow: 0 8px 32px rgba(64, 158, 255, 0.2);
    }
}

.selection-glow {
    position: absolute;
    top: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 200px;
    height: 100px;
    background: radial-gradient(ellipse, rgba(64, 158, 255, 0.3) 0%, transparent 70%);
    animation: glow-pulse 2s ease-in-out infinite;
    pointer-events: none;
}

@keyframes glow-pulse {

    0%,
    100% {
        opacity: 0.6;
        transform: translateX(-50%) scale(1);
    }

    50% {
        opacity: 1;
        transform: translateX(-50%) scale(1.1);
    }
}

.selection-number {
    font-size: 64px;
    font-weight: bold;
    color: #c0c4cc;
    letter-spacing: 4px;
    line-height: 1;
    padding: 16px 32px;
    border-radius: 12px;
    background: #fff;
    border: 1px solid #e4e7ed;
    min-width: 200px;
    min-height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    position: relative;
    z-index: 1;

    &.is-empty {
        color: #dcdfe6;
        font-size: 48px;
        font-style: italic;
    }

    &.is-running {
        color: #409eff;
        background: linear-gradient(180deg, #ecf5ff 0%, #ffffff 100%);
        border-color: #d9ecff;
        animation: selection-roll 0.12s linear infinite, shadow-pulse 1s ease-in-out infinite;
    }

    &.is-result {
        color: #409eff;
        font-size: 56px;
        font-weight: 700;
        background: linear-gradient(135deg, #409eff 0%, #66b1ff 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        text-shadow: 0 2px 4px rgba(64, 158, 255, 0.2);
    }
}

@keyframes selection-roll {
    0% {
        transform: translateY(-2px);
        opacity: 0.85;
    }

    50% {
        transform: translateY(2px);
        opacity: 1;
    }

    100% {
        transform: translateY(-2px);
        opacity: 0.85;
    }
}

@keyframes shadow-pulse {

    0%,
    100% {
        box-shadow: 0 4px 12px rgba(64, 158, 255, 0.2);
    }

    50% {
        box-shadow: 0 4px 24px rgba(64, 158, 255, 0.4);
    }
}

.selection-label {
    margin-top: 12px;
    color: #909399;
    font-size: 13px;
    letter-spacing: 2px;
}

.selection-success {
    margin-top: 20px;
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 12px 24px;
    background: linear-gradient(135deg, #f0f9eb 0%, #e1f3d8 100%);
    border: 1px solid #c2e7b0;
    border-radius: 24px;

    .success-icon-wrap {
        width: 28px;
        height: 28px;
        background: #67c23a;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;

        i {
            color: #fff;
            font-size: 18px;
        }
    }

    .success-text {
        color: #67c23a;
        font-size: 15px;
        font-weight: 500;

        em {
            font-style: normal;
            font-weight: 700;
            font-size: 18px;
        }
    }
}

.selection-error {
    margin-top: 16px;
    color: #f56c6c;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 10px 16px;
    background: #fef0f0;
    border: 1px solid #fde2e2;
    border-radius: 8px;

    i {
        font-size: 18px;
    }
}

// 过渡动画
.success-fade-enter-active,
.success-fade-leave-active {
    transition: all 0.4s ease;
}

.success-fade-enter,
.success-fade-leave-to {
    opacity: 0;
    transform: translateY(-10px);
}

.error-fade-enter-active,
.error-fade-leave-active {
    transition: all 0.3s ease;
}

.error-fade-enter,
.error-fade-leave-to {
    opacity: 0;
    transform: translateY(-5px);
}
</style>